/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ———————— ↓');
      // console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
      document.dispatchEvent(new CustomEvent("zapiet:start"));
      // v43 (2026-05-06): DISABLED — was firing on every cart change and re-adding
      // cross-products with quantity=undefined (Shopify defaults to 1) because v29
      // moves the .cross-product__input into the row's expanded panel, making the
      // legacy `$(this).find(".cross-product__input").val()` selector return null.
      // batida-drawer.js v42 handles cross-product additions in the same /cart/add
      // call as the main item, with the correct quantity from the stepper input.
      // Leaving the function defined below for reference / git-history clarity.
      // addCrossSellProducts();
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    // console.log('theme:cart:init');
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // $(document).ready(function() {

  // 24.09 audit: addEventListener, so this no longer overwrites (or gets
  // overwritten by) another window.onload handler.
  window.addEventListener("load", function () {
    productGridItemAddToCart();
    if ($(window).width() > 767) {
      toggleFilters();
    }
  });

  // Cart Vat
  $("#cart__company-trigger").on("change", () => {
    cartCompanyTrigger();
  });

  function cartCompanyTrigger() {
    if ($("#cart__company-trigger").is(":checked") == false) {
      $(".cart__company-fields").css("display", "none");
      $(".cart__company-fields > .input--required").removeAttr("required");
    } else {
      $(".cart__company-fields").css("display", "block");
      $(".cart__company-fields > .input--required").attr("required", true);
    }
  }
  cartCompanyTrigger();

  // Collection grid item 'Add to cart' button
  function productGridItemAddToCart() {
    $(".product-grid-item__add-to-cart").click(function (e) {
      e.preventDefault();
      let variantID = $(this).data("variant-id");
      jQuery
        .post("/cart/add.js", {
          items: [
            {
              quantity: 1,
              id: variantID,
            },
          ],
        })
        .done(function (response) {
          var response = JSON.parse(response);
          document.dispatchEvent(
            new CustomEvent("theme:cart:popdown", {
              detail: {
                variant: variantID,
              },
              bubbles: true,
            })
          );
          // document.dispatchEvent(new CustomEvent('theme:cart:change', {
          //     detail: {
          //       cart: response.data,
          //     },
          //     bubbles: true
          // }));
          // const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
          // cartDrawer.dispatchEvent(
          //   new CustomEvent('theme:drawer:open', {
          //     bubbles: false,
          //   })
          // );
        });
    });
  }

  //filters
  if ($(window).width() > 767) {
    var urlFilters = false;
    var filterUrlParams = new URLSearchParams(window.location.search);
    filterUrlParams.forEach((value, key) => {
      if (key.includes("filter")) {
        urlFilters = true;
      }
    });
    var filtersActive = false;
    $(".sidebar__navigation__list > li")
      .each(function () {
        if ($(this).children("input").is(":checked") || urlFilters == true) {
          filtersActive = true;
        }
      })
      .promise()
      .done(function () {
        if (filtersActive == true) {
          $(".collection__filters__wrapper").addClass(
            "drawer--visible-important"
          );
        }
      });

    function toggleFilters() {
      $(".collection__filters__toggle").click(function () {
        if (
          $(".collection__filters__wrapper").hasClass(
            "drawer--visible-important"
          )
        ) {
          $(".collection__filters__wrapper").removeClass(
            "drawer--visible-important"
          );
          $(".hide-filters").removeClass("active");
          $(".show-filters").addClass("active");
        } else {
          $(".collection__filters__wrapper").addClass(
            "drawer--visible-important"
          );
          $(".show-filters").removeClass("active");
          $(".hide-filters").addClass("active");
        }
      });
    }
  }

  // Cake inscription / photo properties — shared helpers used by the change
  // handler (radio button toggle) and the window.load handler (re-apply on
  // page reload). Refactored 2026-05-02 from two ~3KB copy-pasted blocks.
  function __getCakeInscriptionMarkup() {
    if (!$(".prod_cake_text")[0]) return null;
    var $ct = $(".prod_cake_text");
    var ch_limit_type = $ct.attr("data-cakech");
    var ch_limit = ch_limit_type === "cake text big" ? 100 : 30;
    var lbl_txt = ch_limit_type === "cake text big"
      ? $ct.attr("data-cakelbl2")
      : $ct.attr("data-cakelbl1");
    var lbl_txt_3 = $ct.attr("data-cakelbl3");
    var lbl_txt_4 = $ct.attr("data-cakelbl4");
    var lbl_txt_5 = $ct.attr("data-cakelbl5");
    var hval =
      '<label for="bp_sign" class="radio__legend__label radio__legend__label--alt">' +
      lbl_txt +
      '</label><textarea maxlength="' +
      ch_limit +
      '" id="bp_text" name="properties[Napis/Sign]"></textarea>';
    var hval2 =
      '<label for="upload" class="radio__legend__label radio__legend__label--alt">' +
      lbl_txt_3 +
      '</label><label for="cake_files" class="btn_cake_file">' +
      lbl_txt_5 +
      '</label><span class="cake_up_img"></span><input style="display:none;" required class="required" id="cake_files" type="file" name="properties[' +
      lbl_txt_4 +
      ']" class="product-form__input"><br>';
    return { hval: hval, hval2: hval2 };
  }

  function __normalizeCakeCval(rawValue) {
    var cval = (rawValue || "").toLowerCase();
    // v63 — normalize via batidaI18n synonyms (pl/en/uk/fr/de) → canonical Polish tak/nie
    if (window.batidaI18n && window.batidaI18n.isYesValue(cval)) return "tak";
    if (window.batidaI18n && window.batidaI18n.isNoValue(cval))  return "nie";
    if (cval === "picture") return "zdjęcie";
    if (cval === "picture + inscription") return "zdjęcie+napis";
    return cval;
  }

  function __applyCakeInscriptionUI(cval, markup) {
    /* BS-32: skip legacy perso surgery when the v2 SSR card is present */ if (document.querySelector('[data-perso-v2]')) return;
    var $litem = $(".litem");
    $litem.html("");
    if (cval === "tak") {
      $litem.append(markup.hval);
      if (typeof window.inscriptionValidation === "function") {
        window.inscriptionValidation();
      }
    } else if (cval === "zdjęcie") {
      $litem.html(markup.hval2);
    } else if (cval === "zdjęcie+napis") {
      $litem.html(markup.hval + markup.hval2);
    }
    // cval === "nie" → already cleared above
  }

  // Change handler — fires when the user picks Napis / Zdjęcie / Zdjęcie+Napis.
  $(" .radio__button-input--inscription").change(function () {
    var markup = __getCakeInscriptionMarkup();
    if (!markup) return;
    __applyCakeInscriptionUI(__normalizeCakeCval($(this).val()), markup);
  });

  $("body").on("change", "#cake_files", function () {
    var ck_ext = $("#cake_files").val().split(".").pop().toLowerCase();
    if ($.inArray(ck_ext, ["gif", "png", "jpg", "jpeg"]) == -1) {
      var lbl_txt_6 = $(".prod_cake_text").attr("data-cakelbl6");
      //alert('invalid extension!');
      $("#cake_files").val("");
      $(".cake_up_img").html(
        '<span class="btn_cake_file_error">' + lbl_txt_6 + "</span>"
      );
    } else {
      $(".cake_up_img").html(
        '<span class="btn_cake_file_success">' + this.files[0].name + "</span>"
      );
    }
  });

  window.inscriptionValidation = function () {
    // required field validation
    if ($("#bp_text").length > 0) {
      $(".btn--add-to-cart").attr("disabled", true);
      $("#bp_text").css("border-color", "#c00");
    }
    $("#bp_text").on("input", function () {
      // required field validation
      if ($(this).val().length > 0) {
        $(".btn--add-to-cart").attr("disabled", false);
        $(this).css("border-color", "#D9D9D9");
      } else {
        $(".btn--add-to-cart").attr("disabled", true);
        $(this).css("border-color", "#c00");
      }
      // prevent special characters and emoticons
      $(this).val(
        $(this)
          .val()
          .replace(/[^a-z0-9żźćńółęąśŻŹĆĄŚĘŁÓŃ\- #+,.!?\n]/gi, "")
      );
    });
  };

  // Window load handler — re-apply the currently-checked inscription option
  // after a page reload (e.g. when returning via back button with a selection
  // still active). Replays the same logic as the change handler above.
  $(window).on("load", function () {
    var markup = __getCakeInscriptionMarkup();
    if (!markup) return;
    $(".product-page--variants .radio__button-input--inscription:checked").each(function () {
      __applyCakeInscriptionUI(__normalizeCakeCval($(this).val()), markup);
    });
  });

  function addCrossSellProducts() {
    if ($(".cross-products").length > 0) {
      let items = [];
      $(".cross-product")
        .each(function () {
          if ($(this).children(".cross-product__checkbox").is(":checked")) {
            let itemQuantity = $(this).find(".cross-product__input").val();
            let itemProperty = $(this)
              .find(".cross-product__input--property")
              .val();
            let itemCandlesNumbers = $(this)
              .find(".cross-product__input-text--candles")
              .val();
            items.push({
              quantity: itemQuantity,
              id: $(this)
                .children(".cross-product__checkbox")
                .data("variant-id"),
              properties: {
                message: itemProperty,
                candles: itemCandlesNumbers,
              },
            });
          }
        })
        .promise()
        .done(function () {
          if (items.length > 0) {
            jQuery
              .post("/cart/add.js", {
                items: items,
              })
              .done(function (response) {
                var response = JSON.parse(response);
              });
          }
        });
    }
  }

  $(".cross-product__input-text--candles").change(function () {
    var candlesQuantity = $(this).val().length;
    $(".cross-product__input--candles-quantity").val(candlesQuantity);
    if (candlesQuantity == 2) {
      $(".cross-product__label-candles").html(
        $(".cross-product__label-candles").html().replace(" x2", "") + " x2"
      );
    } else {
      $(".cross-product__label-candles").html(
        $(".cross-product__label-candles").html().replace(" x2", "")
      );
    }
  });

  // Zapiet restricted dates widget callbacks
  // 24.09 audit: guarded, so a late-loading Zapiet can't stop the rest of this file.
  if (window.ZapietEvent && window.ZapietEvent.listen) window.ZapietEvent.listen("locationSelected", function (e) {
    $(".cart__zapiet-date-check > input").val("");
    $(".zapiet-date-check__success").removeClass("active");
    var todayDate = new Date().toISOString().split("T")[0];
    $(".cart__zapiet-date-check > input").attr("min", todayDate);
    // setTimeout(function() {
    // if ($('#storePickupApp').find('.datePicker').length == 0) {

    $(".cart__zapiet-date-check").fadeIn();
    $(".cart__zapiet-date-check > input").unbind();
    $(".cart__zapiet-date-check > input").change(function () {
      let selectedDate = $(this).val();
      let selectedLocation = e.location.id;
      let selectedMethod = e.method;
      let restrictedProductInCart = false;
      $(".cart__items__row")
        .each(function (e) {
          var cartRow = $(this);
          if (selectedMethod == "pickup") {
            var restrictedDates = $(this).data(
              "product-pickup-date-restrictions"
            );
          } else {
            var restrictedDates = $(this).data(
              "product-delivery-date-restrictions"
            );
          }
          if (restrictedDates !== null) {
            restrictedDates.forEach(function (entry) {
              if (entry.location_id == selectedLocation) {
                if (entry.restricted_dates !== undefined) {
                  if (entry.restricted_dates.includes(selectedDate)) {
                    cartRow
                      .find(".cart__items__product-restricted")
                      .empty()
                      .append(cartRow.data("product-date-restrictions-msg"));
                    restrictedProductInCart = true;
                  } else {
                    cartRow.find(".cart__items__product-restricted").empty();
                    $(".zapiet-date-check__success").addClass("active");
                  }
                }
              }
            });
            // console.log(restrictedDates);
          }
        })
        .promise()
        .done(function () {
          if (restrictedProductInCart) {
            $(".zapiet-date-check__success").removeClass("active");
            $("html, body")
              .stop()
              .animate(
                {
                  scrollTop: $(".cart__items__grid").offset().top - 1,
                },
                500
              );
          }
        });
    });
    // }
    // }, 2000);
  });

  // });

  // ----- DOM repositioning + view_product hover (moved inside IIFE 2026-05-02) -----
  // Wait for the DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function () {
    
    // Select the elements
    var lineItemPropertyField = document.querySelector('.line-item-property__field');
    var crossProducts = document.querySelector('.cross-products');

    // Check if both elements exist
    if (lineItemPropertyField && crossProducts) {
      
      // Append the cross-products element below line-item-property__field
      lineItemPropertyField.parentNode.insertBefore(crossProducts, lineItemPropertyField.nextSibling);
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    
    // Select the elements
    var lineItemPropertyField = document.querySelector('.line-item-property__field');
    var productQuantity = document.querySelector('.product__block__quantity');

    // Check if both elements exist
    if (lineItemPropertyField && productQuantity) {
      
      // Move the product__block__quantity below line-item-property__field
      lineItemPropertyField.parentNode.insertBefore(productQuantity, lineItemPropertyField.nextSibling);
    }
  });
  $(document).ready(function(){
    $(".view_product").hover(
      function(){
        $(this).css("background-color", "#e3d5ca");
        //$(this).text("Mouse in!");
        var data_id = $(this).attr("data-id");
        $("#"+data_id).show();
      },
      function(){
        $(this).css("background-color", "");
         var data_id = $(this).attr("data-id");
        $("#"+data_id).hide();
        //$(this).text("Hover over me!");
      }
    );
  });

})();


/* =====================================================================
   v63 — Phase A: language-agnostic helpers (Pat 2026-05-05)
   Refactor target: every text-based selector that broke when Caroline's
   storefront was switched to English. Pipeline emits these stable hooks
   regardless of locale:
   - .selector-wrapper has data-option-position="N" (1, 2, 3...)
   - inscription radios have class .radio__button-input--inscription
     (Pipeline derives this from the product's "cake text" tag, not from
     the option name — same class in pl/en/uk/fr/de/etc.)
   - variant values (TAK/NIE) stay as configured in admin unless Caroline
     uses Translate & Adapt — we match against synonyms in 5 languages.

   Languages covered: Polish, English, Ukrainian, French, German.
   To support more languages later, extend YES_VALUES / NO_VALUES below.
   ===================================================================== */
window.batidaI18n = window.batidaI18n || (function () {
	// Yes/No synonyms across pl, en, uk, fr, de — case-insensitive.
	var YES_VALUES = ['tak', 'yes', 'так', 'oui', 'ja'];
	var NO_VALUES  = ['nie', 'no',  'ні',  'non', 'nein'];

	function normalize(s) { return (s == null ? '' : String(s)).trim().toLowerCase(); }

	function isYesValue(v) { return YES_VALUES.indexOf(normalize(v)) !== -1; }
	function isNoValue(v)  { return NO_VALUES.indexOf(normalize(v))  !== -1; }

	// Find a .selector-wrapper by Pipeline's data-option-position attribute (1-indexed).
	function findOptionWrapper(position) {
		if (!position) return null;
		var w = document.querySelector('.selector-wrapper[data-option-position="' + position + '"]');
		if (w) return w;
		// Fallback: nth wrapper in source order
		var all = document.querySelectorAll('.selector-wrapper');
		return all[position - 1] || null;
	}

	// The inscription wrapper is the one containing radios with class
	// .radio__button-input--inscription (Pipeline emits this for "cake text" products).
	// Falls back to a wrapper whose values look like a yes/no pair.
	function findInscriptionWrapper() {
		var inscription = document.querySelector('.radio__button-input--inscription');
		if (inscription) return inscription.closest('.selector-wrapper');
		var wrappers = document.querySelectorAll('.selector-wrapper');
		for (var i = 0; i < wrappers.length; i++) {
			var radios = wrappers[i].querySelectorAll('input[type="radio"]');
			var hasYes = false, hasNo = false;
			for (var j = 0; j < radios.length; j++) {
				if (isYesValue(radios[j].value)) hasYes = true;
				if (isNoValue(radios[j].value))  hasNo  = true;
			}
			if (hasYes && hasNo) return wrappers[i];
		}
		return null;
	}

	// The size/Średnica wrapper is option position 1 in Caroline's catalog.
	function findSizeWrapper() { return findOptionWrapper(1); }

	function findYesRadio(wrapper) {
		if (!wrapper) return null;
		var radios = wrapper.querySelectorAll('input[type="radio"]');
		for (var i = 0; i < radios.length; i++) {
			if (isYesValue(radios[i].value)) return radios[i];
		}
		return null;
	}
	function findNoRadio(wrapper) {
		if (!wrapper) return null;
		var radios = wrapper.querySelectorAll('input[type="radio"]');
		for (var i = 0; i < radios.length; i++) {
			if (isNoValue(radios[i].value)) return radios[i];
		}
		return null;
	}

	// v41 (2026-05-06): build a locale-aware product URL. Translate & Adapt
	// localizes product handles per locale (e.g. mus-czekoladowy → schokoladenmousse
	// on /de/). The /products/{handle}.js endpoint then ONLY resolves under the
	// matching locale prefix — /products/schokoladenmousse.js 404s on PL, but
	// /de/products/schokoladenmousse.js works on DE. Use Shopify.routes.root
	// (set by Shopify per-locale: "/" on PL, "/de/" on DE, etc.) as the prefix.
	//
	// v69 (2026-05-07): for cross-products, T Lab also translates the className
	// per locale (cross-product--napisz-swoj-list → cross-product--sheet on EN).
	// The caller passes the CANONICAL Polish handle (from data-canonical-handle
	// stamped by v34); we look up the matching .cross-product node by canonical
	// handle and read its localized handle from the className. This eliminates
	// the race-condition with batida-napis-atc-sync.js's overrideProductUrl
	// (which previously did this lookup but ran in a different IIFE — if its
	// init fired before custom.js defined batidaI18n, the override never
	// stuck and fetchProduct hit /en/products/<canonical>.js → 404). By
	// baking the lookup directly into v63's productUrl, there's nothing to
	// override and no race possible.
	function productUrl(handle) {
		var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
		var localized = handle;
		try {
			var cp = document.querySelector('.cross-product[data-canonical-handle="' + handle + '"]');
			if (cp) {
				var m = (cp.className || '').match(/cross-product--(\S+)/);
				if (m && m[1]) localized = m[1];
			}
		} catch (e) { /* fail-open: fall back to canonical handle */ }
		return root.replace(/\/$/, '') + '/products/' + encodeURIComponent(localized) + '.js';
	}

	return {
		YES_VALUES: YES_VALUES, NO_VALUES: NO_VALUES,
		isYesValue: isYesValue, isNoValue: isNoValue,
		findOptionWrapper: findOptionWrapper,
		findInscriptionWrapper: findInscriptionWrapper,
		findSizeWrapper: findSizeWrapper,
		findYesRadio: findYesRadio, findNoRadio: findNoRadio,
		productUrl: productUrl
	};
})();


/* =====================================================================
   v11 — PDP UX upgrade (Pat 2026-05-03)
   Three small IIFEs:
   A. NAPIS field DOM mover — relocates .line-item-property__field.litem
      directly under the inscription radio fieldset and toggles its
      visibility based on TAK/NIE selection. No liquid edit needed.
   B. Upsell add/remove toggle — clicking an empty card adds product to
      cart via /cart/add.js and marks --added. Clicking an --added card
      removes it via /cart/change.js and clears the marker.
   C. Cart-state sync on page load — checks current cart for upsell
      products and pre-marks any cards already in cart as --added.
   ===================================================================== */

/* A. NAPIS field positioning + reveal */
(function napisFieldRelocator() {
	function init() {
		// Find inscription radio (added by Pipeline as .radio__button-input--inscription)
		var inscriptionInput = document.querySelector('.radio__button-input--inscription');
		if (!inscriptionInput) return;
		var fieldset = inscriptionInput.closest('.radio__fieldset');
		if (!fieldset) return;

		// Find the cake-text container (.line-item-property__field.litem)
		var litem = document.querySelector('.line-item-property__field.litem');
		if (!litem) return;

		// Move it directly after the inscription fieldset (idempotent)
		if (litem.getAttribute('data-napis-moved') !== '1') {
			fieldset.parentNode.insertBefore(litem, fieldset.nextSibling);
			litem.setAttribute('data-napis-moved', '1');
		}

		// Determine current selection and reveal/hide accordingly
		function syncVisibility() {
			var checked = fieldset.querySelector('.radio__button-input--inscription:checked');
			var val = checked ? (checked.value || '').toLowerCase() : '';
			// v63 — anything non-NO reveals the field (yes/tak/oui/ja/так = show inscription input)
			var isNo = window.batidaI18n ? window.batidaI18n.isNoValue(val) : (val === 'nie' || val === 'no');
			if (checked && !isNo && val !== '') {
				litem.removeAttribute('hidden');
			} else {
				litem.setAttribute('hidden', '');
			}
		}
		syncVisibility();

		// Listen for changes on all inscription radios
		fieldset.querySelectorAll('.radio__button-input--inscription').forEach(function (r) {
			r.addEventListener('change', syncVisibility);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
		// Re-run after slight delay in case cake-text JS injects content async
		setTimeout(init, 600);
	} else {
		init();
		setTimeout(init, 600);
	}
})();


/* B + C. Upsell add/remove toggle + initial cart-state sync */
(function upsellToggle() {
	var ADDED_CLASS = 'product-clip__btn--added';

	// Pull the variant ID from a hidden id input within the same form/wrapper as the button
	function getVariantId(btn) {
		var form = btn.closest('form');
		if (!form) return null;
		var idInput = form.querySelector('input[name="id"]');
		return idInput ? idInput.value : null;
	}

	function findCartItemKey(variantId) {
		return fetch('/cart.js', { credentials: 'same-origin' })
			.then(function (r) { return r.json(); })
			.then(function (cart) {
				var match = cart.items.find(function (i) {
					return String(i.variant_id) === String(variantId) || String(i.id) === String(variantId);
				});
				return match ? match.key : null;
			});
	}

	function addToCart(variantId) {
		return fetch('/cart/add.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ id: variantId, quantity: 1 })
		}).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
	}

	function removeFromCart(key) {
		return fetch('/cart/change.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ id: key, quantity: 0 })
		}).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
	}

	function refreshAjaxCart() {
		// Pipeline / Batida theme uses an event-based cart drawer refresh.
		// Fire a few common events so any open mini-cart updates.
		document.dispatchEvent(new CustomEvent('cart:updated'));
		document.dispatchEvent(new CustomEvent('cart:refresh'));
		if (window.theme && typeof window.theme.cart === 'object' && typeof window.theme.cart.refresh === 'function') {
			try { window.theme.cart.refresh(); } catch (e) {}
		}
	}

	function bindCard(btn) {
		if (btn.getAttribute('data-v11-bound') === '1') return;
		// v85 (2026-05-08): if this button lives inside a .quickview wrapper,
		// it belongs to v12UpsellHandler — v11 must NOT also bind it or each
		// click fires BOTH addToCart paths and the cart receives qty=2 instead
		// of qty=1. Pat caught this on Mango → Fistaszek upsell.
		if (btn.closest('.quickview')) return;
		btn.setAttribute('data-v11-bound', '1');

		btn.addEventListener('click', function (ev) {
			// Intercept Pipeline's default form submit so we can do add-or-remove
			ev.preventDefault();
			ev.stopPropagation();

			var variantId = getVariantId(btn);
			if (!variantId) return;

			if (btn.classList.contains(ADDED_CLASS)) {
				// REMOVE flow
				btn.disabled = true;
				findCartItemKey(variantId)
					.then(function (key) {
						if (!key) {
							btn.classList.remove(ADDED_CLASS);
							btn.disabled = false;
							return;
						}
						return removeFromCart(key).then(function () {
							btn.classList.remove(ADDED_CLASS);
							btn.disabled = false;
							refreshAjaxCart();
						});
					})
					.catch(function () { btn.disabled = false; });
			} else {
				// ADD flow
				btn.disabled = true;
				addToCart(variantId)
					.then(function () {
						btn.classList.add(ADDED_CLASS);
						btn.disabled = false;
						refreshAjaxCart();
					})
					.catch(function () { btn.disabled = false; });
			}
		}, true /* capture phase to beat Pipeline's own submit handler */);
	}

	function bindAll() {
		document.querySelectorAll('.upsell__holder--hybrid .product-clip__btn').forEach(bindCard);
	}

	function syncFromCart() {
		if (!document.querySelector('.upsell__holder--hybrid .product-clip__btn')) return;   // 2.10 (Astra speed report PERF-01): no upsell buttons = nothing to mark, skip the /cart.js read
		fetch('/cart.js', { credentials: 'same-origin' })
			.then(function (r) { return r.json(); })
			.then(function (cart) {
				var inCart = new Set(cart.items.map(function (i) { return String(i.variant_id); }));
				document.querySelectorAll('.upsell__holder--hybrid .product-clip__btn').forEach(function (btn) {
					var v = getVariantId(btn);
					if (v && inCart.has(String(v))) {
						btn.classList.add(ADDED_CLASS);
					}
				});
			})
			.catch(function () {});
	}

	function init() {
		bindAll();
		syncFromCart();
		// The hybrid hydration top-up runs on a delay; re-bind after that fires
		setTimeout(function () { bindAll(); syncFromCart(); }, 1500);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


/* =====================================================================
   v12 — PDP behavioral upgrades (Pat 2026-05-03)
   Supersedes the v11 IIFEs above. Marks buttons with data-v12 to
   prevent v11 handlers from double-binding. Three IIFEs:
   A. Upsell add/remove — fixed variant lookup via product handle
   B. SREDNICA visual size card renderer
   C. Dodatki do tortu — replaces NAPIS variant with toggle UI
   ===================================================================== */

/* SVG icon strings for size cards */
window.__BATIDA_V12_SIZE_ICON_SM = '<svg class="bsc-icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><ellipse cx="16" cy="22" rx="11" ry="3"/><path d="M5 22V14M27 22V14"/><ellipse cx="16" cy="14" rx="11" ry="3"/><path d="M11 8v6M16 6v8M21 8v6"/></svg>';
window.__BATIDA_V12_SIZE_ICON_LG = '<svg class="bsc-icon bsc-icon-lg" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><ellipse cx="16" cy="24" rx="14" ry="3"/><path d="M2 24V12M30 24V12"/><ellipse cx="16" cy="12" rx="14" ry="3"/><path d="M9 5v8M16 3v10M23 5v8"/></svg>';


/* === A. Upsell add/remove with fixed variant lookup === */
(function v12UpsellHandler() {
	var ADDED = 'product-clip__btn--added';
	var handleCache = {}; // handle -> { firstAvailableVariantId, ...}

	function getProductInfo(btn) {
		// Upsell quickview wrapper has id="{productId}-btn-div" and
		// x-data="productQuickViewButton({productId}, '{handle}')"
		var quickview = btn.closest('.quickview');
		if (!quickview) return null;
		var xData = quickview.getAttribute('x-data') || '';
		var match = xData.match(/productQuickViewButton\((\d+)\s*,\s*['"]([^'"]+)['"]\)/);
		if (!match) return null;
		return { productId: match[1], handle: match[2] };
	}

	function fetchProduct(handle) {
		if (handleCache[handle]) return Promise.resolve(handleCache[handle]);
		// v41 (2026-05-06): use locale-aware URL — handles are localized in non-PL
		var __url = (window.batidaI18n && window.batidaI18n.productUrl) ? window.batidaI18n.productUrl(handle) : '/products/' + encodeURIComponent(handle) + '.js';
		return fetch(__url, { credentials: 'same-origin' })
			.then(function (r) { return r.json(); })
			.then(function (p) {
				handleCache[handle] = p;
				return p;
			});
	}

	function getFirstAvailableVariantId(product) {
		if (!product || !product.variants) return null;
		var v = product.variants.find(function (x) { return x.available; });
		return v ? v.id : (product.variants[0] ? product.variants[0].id : null);
	}

	function findCartItemKey(variantId) {
		return fetch('/cart.js', { credentials: 'same-origin' })
			.then(function (r) { return r.json(); })
			.then(function (cart) {
				var match = cart.items.find(function (i) {
					return String(i.variant_id) === String(variantId);
				});
				return match ? match.key : null;
			});
	}

	function addToCart(variantId) {
		return fetch('/cart/add.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ id: variantId, quantity: 1 })
		}).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
	}

	function removeFromCart(key) {
		return fetch('/cart/change.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ id: key, quantity: 0 })
		}).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
	}

	function refreshCart() {
		document.dispatchEvent(new CustomEvent('cart:updated'));
		document.dispatchEvent(new CustomEvent('cart:refresh'));
	}

	function bindBtn(btn) {
		if (btn.getAttribute('data-v12-bound') === '1') return;
		btn.setAttribute('data-v12-bound', '1');
		btn.setAttribute('data-v11-bound', '1'); // prevent v11 from double-binding

		btn.addEventListener('click', function (ev) {
			ev.preventDefault();
			ev.stopImmediatePropagation();
			ev.stopPropagation();

			var info = getProductInfo(btn);
			if (!info) return;

			btn.disabled = true;
			fetchProduct(info.handle)
				.then(function (product) {
					var variantId = getFirstAvailableVariantId(product);
					if (!variantId) { btn.disabled = false; return; }

					if (btn.classList.contains(ADDED)) {
						return findCartItemKey(variantId).then(function (key) {
							if (!key) { btn.classList.remove(ADDED); btn.disabled = false; return; }
							return removeFromCart(key).then(function () {
								btn.classList.remove(ADDED);
								btn.disabled = false;
								refreshCart();
							});
						});
					} else {
						return addToCart(variantId).then(function () {
							btn.classList.add(ADDED);
							btn.disabled = false;
							refreshCart();
						});
					}
				})
				.catch(function () { btn.disabled = false; });
		}, true);
	}

	function bindAll() {
		document.querySelectorAll('.upsell__holder--hybrid .product-clip__btn').forEach(bindBtn);
	}

	function syncFromCart() {
		if (!document.querySelector('.upsell__holder--hybrid .product-clip__btn')) return;   // 2.10 (Astra speed report PERF-01): no upsell buttons = nothing to mark, skip the /cart.js read
		fetch('/cart.js', { credentials: 'same-origin' })
			.then(function (r) { return r.json(); })
			.then(function (cart) {
				var inCart = new Set(cart.items.map(function (i) { return String(i.product_id); }));
				document.querySelectorAll('.upsell__holder--hybrid .product-clip__btn').forEach(function (btn) {
					var info = getProductInfo(btn);
					if (info && inCart.has(String(info.productId))) {
						btn.classList.add(ADDED);
					}
				});
			})
			.catch(function () {});
	}

	function init() {
		bindAll();
		syncFromCart();
		setTimeout(function () { bindAll(); syncFromCart(); }, 1500);
		setTimeout(function () { bindAll(); }, 3000); // catch any late hydration
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


/* === B. SREDNICA size cards — replace popout with visual cards === */
(function v12SrednicaCards() {
	function init() {
		// v63 — find by option position, not localized label
		var wrapper = (window.batidaI18n && window.batidaI18n.findSizeWrapper())
			|| document.querySelector('[data-select-label="Średnica"], [data-select-label="Srednica"]');
		if (!wrapper || wrapper.querySelector('.batida-size-cards')) return;

		var hiddenInput = wrapper.querySelector('input[type="hidden"]');
		var popoutOptions = wrapper.querySelectorAll('.select-popout__item');
		var radioInputs = wrapper.querySelectorAll('.radio__button input[type="radio"]');

		// Collect option values from either popout or radio markup
		var values = [];
		if (popoutOptions.length) {
			popoutOptions.forEach(function (li) {
				var a = li.querySelector('a[data-value]');
				if (a) values.push(a.getAttribute('data-value'));
			});
		} else if (radioInputs.length) {
			radioInputs.forEach(function (r) { values.push(r.value); });
		}
		if (!values.length) return;

		// v64 (2026-05-07): bail if option values are pure single-digit strings
		// (0-9). That's the candle-digit picker (Świeczka cyferka), not a cake
		// size option — rendering them as cake-icon size cards is nonsensical
		// and confused customers landing on /products/swieczka-cyferka.
		var allDigits = values.every(function(v){ return /^\d$/.test((v || '').trim()); });
		if (allDigits) return;

		// v82c (2026-05-08): cm-prefix value-shape gate. v12 cake-icon cards
		// make sense ONLY for diameter-based sizing ("18cm (≈8porcji)" /
		// "24cm (≈12porcji)") — the dc-pc archetype Caroline ships under the
		// Średnica option name. For porcji-based sizing on artystyczne /
		// komunia products (label "Rozmiar" or "Ilość porcji", values like
		// "~15 porcji (1piętro)" / "≈15 porcji (1 piętro)"), Pat's call is
		// Pipeline native lists for consistency — option counts vary 3-14
		// across that catalog, no point in cake-card UX that scales to ~6.
		// "cm" is universal across locales (T Lab doesn't translate it).
		// Replaces the v81b label-based gate which was too brittle: it bailed
		// v12 on any product with a porcji-named wrapper anywhere on page,
		// causing accidental asymmetry where Boho (option1=Rozmiar, no porcji
		// label) got v12 cards while Flower-power (option1=Ilość porcji)
		// fell back to popout. Now the value-shape decides: cm = cards,
		// anything else = Pipeline native.
		var allCmSized = values.every(function (v) { return /^\d+\s*(?:cm|см)/i.test((v || '').trim()); });
		if (!allCmSized) return;

		// v81b retained as belt-and-suspenders: bail if this wrapper is the
		// SHAPE option (Kształt / shape / форма / forme / form) — defensive
		// against any future product where shape values would somehow start
		// with cm. v71's cake-configurator owns shape products.
		var SHAPE_OPTION_KW = ['kształt','ksztalt','shape','форма','forme','form'];
		var wrapperLabel = (wrapper.getAttribute('data-select-label') || '').toLowerCase();
		var isShapeWrapper = SHAPE_OPTION_KW.some(function (kw) { return wrapperLabel.indexOf(kw) !== -1; });
		if (isShapeWrapper) return;

		// Get current value to mark selected
		var currentValue = hiddenInput ? hiddenInput.value : (radioInputs[0] ? radioInputs[0].value : values[0]);

		// Build the cards container
		var container = document.createElement('div');
		container.className = 'batida-size-cards';

		values.forEach(function (val, idx) {
			var card = document.createElement('button');
			card.type = 'button';
			card.className = 'batida-size-card';
			if (val === currentValue) card.classList.add('is-selected');
			card.setAttribute('data-value', val);

			// Parse "18cm (≈8porcji)" into size + portions
			var sizeMatch = val.match(/(\d+\s*(?:cm|см))/i);
			// v39b (2026-05-06): T Lab not only translates the suffix word ("porcji" →
			// "Portionen" / "servings" / "порцій") but ALSO mangles the ≈ glyph itself —
			// in DE it's substituted with ½ (U+00BD VULGAR FRACTION ONE HALF), as if it
			// were a fraction. So we can't anchor on ≈/~ either. Anchor on the opening
			// paren and grab the first integer regardless of what glyph precedes it.
			// Matches every observed shape: "18cm (≈8porcji)", "18 cm (½8 Portionen)",
			// "18 cm (~8 servings)", "18 cm (8 portions)".
			var portionMatch = val.match(/\(\D*?(\d+(?:[-–]\d+)?)/);
			var sizeLabel = sizeMatch ? sizeMatch[1].replace(/\s+/g, ' ') : val;
			// v38 (2026-05-06): localize "ok. {N} porcji" per current locale. The
			// raw variant value is always Polish (Caroline's master catalog), but the
			// rendered subtitle should match the storefront language.
			var __batidaLocale = (function () {
				var l = (document.documentElement && document.documentElement.lang) || '';
				return l.toLowerCase().split('-')[0] || 'pl';
			})();
			// v75 (2026-05-08): pulled from window.batidaT bridge → locales/pl.json
			// (T Lab auto-translates batida.size_cards.portion_template per locale).
			// Template uses {{ n }} (with spaces) — keep both forms tolerant.
			var __portionTpl = window.batidaT('size_cards.portion_template', 'ok. {{ n }} porcji');
			var portionLabel = portionMatch
				? __portionTpl.replace(/\{\{\s*n\s*\}\}/g, portionMatch[1]).replace(/\{\s*n\s*\}/g, portionMatch[1])
				: '';

			// Bigger icon for larger sizes (heuristic: index > 0 = larger)
			var iconHtml = idx === 0 ? window.__BATIDA_V12_SIZE_ICON_SM : window.__BATIDA_V12_SIZE_ICON_LG;

			// v40 (2026-05-06): "Popularne" / "Beliebt" badge removed at Pat's request —
			// don't claim a size is popular when we don't have actual sales data behind
			// it. Locale label maps for the badge are kept in case we want to re-enable
			// once real popularity data is wired in.
			card.innerHTML =
				iconHtml +
				'<span class="bsc-size">' + sizeLabel + '</span>' +
				'<span class="bsc-portions">' + portionLabel + '</span>';
			// Price added later via separate observer (Pipeline updates price block on variant change)

			card.addEventListener('click', function () {
				// Update hidden input
				if (hiddenInput) {
					hiddenInput.value = val;
					hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
					hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
				}
				// Also click the corresponding radio if present
				radioInputs.forEach(function (r) {
					if (r.value === val) {
						r.checked = true;
						r.dispatchEvent(new Event('change', { bubbles: true }));
					}
				});
				// Also click the popout option link if present
				var popoutLink = wrapper.querySelector('.select-popout a[data-value="' + val.replace(/"/g, '\\"') + '"]');
				if (popoutLink) popoutLink.click();
				// Update visual selected state
				container.querySelectorAll('.batida-size-card').forEach(function (c) {
					c.classList.toggle('is-selected', c === card);
				});
			});

			container.appendChild(card);
		});

		// Insert at top of selector wrapper
		wrapper.insertBefore(container, wrapper.firstChild);

		// Optional: keep selected state synced if hidden input changes elsewhere
		if (hiddenInput) {
			var observer = new MutationObserver(function () {
				var v = hiddenInput.value;
				container.querySelectorAll('.batida-size-card').forEach(function (c) {
					c.classList.toggle('is-selected', c.getAttribute('data-value') === v);
				});
			});
			observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
		setTimeout(init, 800);
	} else {
		init();
		setTimeout(init, 800);
	}
})();


/* === C. NAPIS as Dodatki toggle — re-render the inscription variant
   as a clean on/off toggle row that fits the cross-products layout === */
(function v12NapisToggle() {
	function init() {
		// v63 — find inscription wrapper by inscription radio class, not localized label
		var wrapper = (window.batidaI18n && window.batidaI18n.findInscriptionWrapper())
			|| document.querySelector('[data-select-label="NAPIS"], [data-select-label="Napis"]');
		if (!wrapper) return;
		// Don't double-render
		if (document.querySelector('[data-perso-v2]')) return; /* BS-32 v2 guard */ if (document.querySelector('.batida-addon-section[data-from="napis"]')) return;

		// v63 — yes/no radios via synonym-matching helper (pl/en/uk/fr/de)
		var nieRadio = window.batidaI18n ? window.batidaI18n.findNoRadio(wrapper)
			: wrapper.querySelector('input[type="radio"][value="NIE"], input[type="radio"][value="Nie"], input[type="radio"][value="nie"]');
		var takRadio = window.batidaI18n ? window.batidaI18n.findYesRadio(wrapper)
			: wrapper.querySelector('input[type="radio"][value="TAK"], input[type="radio"][value="Tak"], input[type="radio"][value="tak"]');

		if (!nieRadio || !takRadio) return;

		// Compute price delta (TAK price - NIE price for current size)
		var priceDelta = '+ 10,00 zł'; // v62/v74f: catalog-wide actual delta; v49 may overwrite from /products/{handle}.js

		// Build the section with toggle
		var section = document.createElement('div');
		section.className = 'batida-addon-section';
		section.setAttribute('data-from', 'napis');
		// v75 (2026-05-08): napis title/subtitle from window.batidaT bridge.
		// Section label "Dodatki do tortu" is legacy (v21 immediately renames to Personalizacja); leave alone.
		var __napisTitle = window.batidaT('napis.title', 'Napis na torcie');
		var __napisSubtitle = window.batidaT('napis.subtitle', 'Ręcznie pisany');
		section.innerHTML =
			'<p class="batida-addon-section__label">Dodatki do tortu</p>' +
			'<div class="batida-addon-row" data-napis-row>' +
				'<div class="batida-addon-row__text">' + __napisTitle + '<small>' + __napisSubtitle + ' · ' + priceDelta + '</small></div>' +
				'<div class="batida-addon-toggle"></div>' +
			'</div>';

		// v82d (2026-05-08): place section AFTER the inscription wrapper, not
		// after the size wrapper. On artystyczne products (Ilość porcji + Smak +
		// Napis), the old "after size" anchor put Personalizacja between option-1
		// and option-2 — wrong. New anchor = inscription wrapper, which Pipeline
		// always emits LAST (as option-2 on dc-pc, option-3 on artystyczne). So
		// the section lands at the end of the variant block, yielding the target
		// visual order: Ilość Porcji → Smak → Personalizacja on artystyczne, and
		// (Średnica → Personalizacja) on dc-pc since the hidden Napis takes no
		// visual space.
		wrapper.parentNode.insertBefore(section, wrapper.nextSibling);

		// Initialize toggle state from current radio
		var row = section.querySelector('[data-napis-row]');
		var isOn = takRadio.checked;
		if (isOn) row.classList.add('is-on');

		// Find or wait for the cake-text textarea container that the
		// existing prod_cake_text JS injects into .line-item-property__field.litem
		// We DON'T move it — we just toggle its visibility based on TAK/NIE.
		var litem = document.querySelector('.line-item-property__field.litem');

		function applyState(on) {
			row.classList.toggle('is-on', on);
			if (on) {
				takRadio.checked = true;
				takRadio.dispatchEvent(new Event('change', { bubbles: true }));
				if (litem) litem.removeAttribute('hidden');
			} else {
				nieRadio.checked = true;
				nieRadio.dispatchEvent(new Event('change', { bubbles: true }));
				if (litem) litem.setAttribute('hidden', '');
			}
		}

		row.addEventListener('click', function () {
			applyState(!row.classList.contains('is-on'));
		});

		// Sync if radio changes from outside
		[nieRadio, takRadio].forEach(function (r) {
			r.addEventListener('change', function () {
				row.classList.toggle('is-on', takRadio.checked);
				if (litem) {
					if (takRadio.checked) litem.removeAttribute('hidden');
					else litem.setAttribute('hidden', '');
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
		setTimeout(init, 1000);
	} else {
		init();
		setTimeout(init, 1000);
	}
})();


/* =====================================================================
   v14 — PDP fixes (Pat 2026-05-03)
   1. NAPIS textarea fallback — inject input if cake-text JS didn't
      populate .line-item-property__field.litem
   2. Group all addons into Dodatki section — move .cross-products
      container into the section so quantity stepper isn't sandwiched
      between addon groups
   ===================================================================== */

(function v14AddonsRegrouper() { if (document.querySelector('[data-perso-v2]')) return; /* BS-32 v2 guard */

	function ensureNapisTextarea() {
		var litem = document.querySelector('.line-item-property__field.litem');
		if (!litem) return;
		// If already has a real input/textarea (injected by cake-text JS), leave it alone
		var hasInput = litem.querySelector('input[type="text"], textarea');
		if (hasInput) return;
		// v74d (2026-05-08): unified placeholder — no per-version variants. localizePlaceholders() in napis-sync will swap per locale.
		// v75 (2026-05-08): final fallback now sourced from window.batidaT bridge → locales/pl.json.
		var v14Placeholder = (window.batidaI18n && window.batidaI18n.napisPlaceholder) || window.batidaT('napis.placeholder', 'Wpisz napis (maks. 30 znaków)');
		litem.innerHTML =
			'<input type="text" id="batida-napis-text" name="properties[Napis/Sign]" maxlength="30" placeholder="' + v14Placeholder.replace(/"/g, '&quot;') + '" autocomplete="off" />';
		litem.setAttribute('data-v14-injected', '1');
	}

	function moveCrossProductsIntoDodatki() {
		var dodatki = document.querySelector('.batida-addon-section[data-from="napis"]');
		var crossProducts = document.querySelector('.cross-products');
		if (!dodatki || !crossProducts) return;
		if (crossProducts.getAttribute('data-v14-moved') === '1') return;

		// Move cross-products inside the Dodatki section so all addons are grouped
		dodatki.appendChild(crossProducts);
		crossProducts.setAttribute('data-v14-moved', '1');

		// v63 — strip the localized "Include " prefix from cross-product labels
		// (Pipeline prefixes the linked product name with a verb that's
		// translated per locale: pl=Dołącz, uk=З'єднувати, en=Include,
		// fr=Inclure/Joindre, de=Hinzufügen). Match smart + dumb apostrophes
		// for Ukrainian; trailing space is mandatory to avoid eating real words.
		var ADDON_PREFIX_RE = /^\s*(?:Dołącz|З[’']єднувати|Include|Inclure|Joindre|Hinzufügen|Beifügen|Додай|Додати)\s+/i;
		crossProducts.querySelectorAll('.cross-product label > span').forEach(function (span) {
			var t = span.textContent.replace(ADDON_PREFIX_RE, '').trim();
			// Only update if we actually removed the prefix (idempotent)
			if (t !== span.textContent.trim()) {
				span.textContent = t;
			}
		});
	}

	function relocateLitemIntoNapisRow() {
		// The .line-item-property__field.litem was moved by v11 next to the
		// (now-hidden) inscription fieldset. Move it INTO the Napis addon row
		// area so the textarea appears directly beneath the toggle.
		var napisRow = document.querySelector('.batida-addon-row[data-napis-row]');
		var litem = document.querySelector('.line-item-property__field.litem');
		if (!napisRow || !litem) return;
		if (litem.getAttribute('data-v14-relocated') === '1') return;

		// Insert immediately after the Napis row (still inside the Dodatki section)
		napisRow.parentNode.insertBefore(litem, napisRow.nextSibling);
		litem.setAttribute('data-v14-relocated', '1');
	}

	function bindNapisToggleToInjector() {
		// Hook into the existing v12 toggle so it injects the textarea on every TAK click
		var row = document.querySelector('.batida-addon-row[data-napis-row]');
		if (!row || row.getAttribute('data-v14-bound') === '1') return;
		row.setAttribute('data-v14-bound', '1');

		// Watch for class changes (is-on toggling) on the row to inject when needed
		var observer = new MutationObserver(function () {
			if (row.classList.contains('is-on')) {
				ensureNapisTextarea();
			}
		});
		observer.observe(row, { attributes: true, attributeFilter: ['class'] });

		// Initial check — if already on at page load, inject immediately
		if (row.classList.contains('is-on')) {
			ensureNapisTextarea();
		}
	}

	function init() {
		relocateLitemIntoNapisRow();
		moveCrossProductsIntoDodatki();
		bindNapisToggleToInjector();
		// v63 — find inscription wrapper + yes radio, language-agnostic
		var inscriptionWrap = window.batidaI18n && window.batidaI18n.findInscriptionWrapper();
		var takRadio = inscriptionWrap
			? window.batidaI18n.findYesRadio(inscriptionWrap)
			: document.querySelector('[data-select-label="NAPIS"] input[type="radio"][value="TAK"], [data-select-label="Napis"] input[type="radio"][value="TAK"]');
		if (takRadio && takRadio.checked) {
			ensureNapisTextarea();
		}
	}

	function initLater() {
		// v12 injects Dodatki section + cross-products may render late; retry a few times
		init();
		setTimeout(init, 500);
		setTimeout(init, 1500);
		setTimeout(init, 3000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLater);
	} else {
		initLater();
	}
})();


/* =====================================================================
   v15 — Override cake-text JS injection with clean single-line input
   ===================================================================== */

(function v15CleanNapisInput() { if (document.querySelector('[data-perso-v2]')) return; /* BS-32 v2 guard */

	function injectClean() {
		var litem = document.querySelector('.line-item-property__field.litem');
		if (!litem) return;

		// If we've already cleaned this litem in this page-life, leave it alone
		// (so user typing isn't wiped out). Re-run only if still uninjected.
		if (litem.getAttribute('data-v15-clean') === '1') return;

		// v74d (2026-05-08): IGNORE cake-text JS label ("NAPIS (MAKS. 30 ZNAK.)") and always use the unified placeholder.
		// Reading existingLabel.textContent caused the bad wording to leak through on every fresh inject after toggle ON.
		// v75 (2026-05-08): final fallback now sourced from window.batidaT bridge → locales/pl.json.
		var v15Placeholder = (window.batidaI18n && window.batidaI18n.napisPlaceholder) || window.batidaT('napis.placeholder', 'Wpisz napis (maks. 30 znaków)');

		// Capture any current value from existing input/textarea so we don't lose user typing
		var existingField = litem.querySelector('input[type="text"], textarea');
		var existingValue = existingField ? existingField.value : '';

		// Replace the litem contents with our clean single-line input
		// v57: property name MUST be "Napis/Sign" — that's the key FoodSoft is mapped to.
		// Renaming this to "Napis" in v15 silently broke the POS integration: Shopify
		// stored the value but FoodSoft's webhook reader only looks at "Napis/Sign".
		litem.innerHTML =
			'<input type="text" id="batida-napis-text" name="properties[Napis/Sign]" maxlength="30" ' +
			'placeholder="' + v15Placeholder.replace(/"/g, '&quot;') + '" autocomplete="off" />';

		// Restore value if user had typed something
		var newField = litem.querySelector('#batida-napis-text');
		if (newField && existingValue) newField.value = existingValue;

		litem.setAttribute('data-v15-clean', '1');
	}

	function watchAndInject() {
		injectClean();
		// The cake-text JS may inject AFTER our first call — observe and re-inject
		var litem = document.querySelector('.line-item-property__field.litem');
		if (!litem) return;
		var observer = new MutationObserver(function () {
			// If the cake-text JS has overwritten our clean input, re-inject
			if (litem.getAttribute('data-v15-clean') !== '1') {
				injectClean();
			}
		});
		observer.observe(litem, { childList: true, subtree: false });
	}

	function init() {
		injectClean();
		// Re-run after cake-text JS may have populated
		setTimeout(injectClean, 600);
		setTimeout(injectClean, 1500);
		setTimeout(watchAndInject, 2000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


/* =====================================================================
   v16 — Napis input: fix re-injection bug from v15
   v15's injectClean() bailed when data-v15-clean=1 was already set, so
   when cake-text JS later overwrote the litem with its own textarea+label,
   our observer fired but immediately bailed out. v16 keys off the
   actual presence of our #batida-napis-text input, not a flag.
   ===================================================================== */

(function v16NapisPersist() { if (document.querySelector('[data-perso-v2]')) return; /* BS-32 v2 guard */
	var INPUT_ID = 'batida-napis-text';
	var observer = null;

	function getLitem() {
		return document.querySelector('.line-item-property__field.litem');
	}

	function injectIfMissing() {
		var litem = getLitem();
		if (!litem) return;
		// Already has our input? Done.
		if (litem.querySelector('#' + INPUT_ID)) return;

		// v74d (2026-05-08): same as v15 — use unified placeholder, never read cake-text JS label
		// v75 (2026-05-08): final fallback now sourced from window.batidaT bridge → locales/pl.json.
		var v16Placeholder = (window.batidaI18n && window.batidaI18n.napisPlaceholder) || window.batidaT('napis.placeholder', 'Wpisz napis (maks. 30 znaków)');

		// Capture any existing typed value
		var existingField = litem.querySelector('input[type="text"], textarea');
		var existingValue = existingField ? existingField.value : '';

		// Clean replace — see v57 note above re: properties[Napis/Sign] vs properties[Napis]
		litem.innerHTML =
			'<input type="text" id="' + INPUT_ID + '" name="properties[Napis/Sign]" maxlength="30" ' +
			'placeholder="' + v16Placeholder.replace(/"/g, '&quot;') + '" autocomplete="off" />';
		litem.setAttribute('data-v15-clean', '1');

		var newInput = litem.querySelector('#' + INPUT_ID);
		if (newInput && existingValue) newInput.value = existingValue;
	}

	function startWatcher() {
		var litem = getLitem();
		if (!litem || observer) return;
		observer = new MutationObserver(function () {
			// If our input is gone, the cake-text JS overwrote us. Re-inject.
			if (!litem.querySelector('#' + INPUT_ID)) {
				injectIfMissing();
			}
		});
		observer.observe(litem, { childList: true, subtree: false });
	}

	function init() {
		injectIfMissing();
		startWatcher();
		// Belt-and-suspenders: re-check on a few timers in case the litem
		// itself was added late (some Pipeline pages render the form async)
		setTimeout(function () { injectIfMissing(); startWatcher(); }, 800);
		setTimeout(function () { injectIfMissing(); startWatcher(); }, 2000);
		setTimeout(function () { injectIfMissing(); startWatcher(); }, 4000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


/* =====================================================================
   v18 — Size card price sync + upcharge display (Pat 2026-05-03)
   Pipeline's price block is server-rendered from Liquid and not bound
   to Alpine variantId. Manual approach: fetch product data once, on
   any variant-affecting interaction find the correct variant via
   current Średnica + NAPIS values, update displayed price + ATC text
   + Alpine state.
   Also renders price per size card + "+ XXX zł" upcharge on larger card.
   Tested live in browser before shipping.
   ===================================================================== */

(function v18PriceSync() {
	var product = null;

	function getHandle() {
		// Pull product handle from <link rel="canonical"> or URL
		var link = document.querySelector('link[rel="canonical"]');
		if (link && link.href) {
			var m = link.href.match(/\/products\/([^/?#]+)/);
			if (m) return m[1];
		}
		var pathMatch = location.pathname.match(/\/products\/([^/?#]+)/);
		return pathMatch ? pathMatch[1] : null;
	}

	function fetchProduct() {
		var handle = getHandle();
		if (!handle) return Promise.resolve(null);
		// v41 (2026-05-06): use locale-aware URL — handles are localized in non-PL
		var __url = (window.batidaI18n && window.batidaI18n.productUrl) ? window.batidaI18n.productUrl(handle) : '/products/' + handle + '.js';
		return fetch(__url, { credentials: 'same-origin' })
			.then(function (r) { return r.ok ? r.json() : null; })
			.catch(function () { return null; });
	}

	function getOptionValue(optionPositionOrName) {
		// v63 — accept numeric position (preferred, language-agnostic) OR legacy localized name
		var wrapper;
		if (typeof optionPositionOrName === 'number' && window.batidaI18n) {
			wrapper = window.batidaI18n.findOptionWrapper(optionPositionOrName);
		} else {
			wrapper = document.querySelector('[data-select-label="' + optionPositionOrName + '"]');
		}
		if (!wrapper) return null;
		var hidden = wrapper.querySelector('input[type="hidden"][name^="options"]');
		if (hidden) return hidden.value;
		var radio = wrapper.querySelector('input[type="radio"]:checked');
		if (radio) return radio.value;
		return null;
	}

	function findVariantForCurrent() {
		if (!product) return null;
		// v79 (2026-05-08): single-variant fast-path. Products with only one
		// variant (monoporcje, coffee, quiche on bez-wariantow template) have
		// no size-card selector to read from, so getOptionValue() returns
		// undefined and the .find() match fails → updateDisplayedPrice() bails
		// → ATC stays at Liquid-default no-decimals price. Short-circuit here.
		if (product.variants && product.variants.length === 1) {
			return product.variants[0];
		}
		var optMap = {};
		product.options.forEach(function (opt, i) {
			// v63 — query by 1-indexed position (works in any locale)
			optMap[opt.name] = getOptionValue(i + 1);
		});
		// v40b (2026-05-06): in non-PL locales the form's hidden inputs hold the
		// Translate-&-Adapt-localized variant values ("18 cm (½8 Portionen)") while
		// product.variants[].options[] holds the master Polish form ("18cm (≈8porcji)").
		// Strict === never matched → returned null → price didn't update on size change
		// AND Alpine variantId stayed stale (cart could submit wrong variant).
		// Compare with three rules: identity, cm-prefix for size, yes/no synonyms for
		// inscription (any locale via window.batidaI18n).
		var __extractSize = function (s) {
			var m = (s || '').match(/(\d+)\s*(?:cm|см)/i);   /* Latin cm or Cyrillic см (UK) */
			return m ? m[1] + 'cm' : null;
		};
		return product.variants.find(function (v) {
			return v.options.every(function (val, i) {
				var optName = product.options[i].name;
				var current = optMap[optName];
				if (current === val) return true;
				var aSize = __extractSize(current);
				var bSize = __extractSize(val);
				if (aSize && bSize && aSize === bSize) return true;
				if (window.batidaI18n) {
					if (window.batidaI18n.isYesValue(current) && window.batidaI18n.isYesValue(val)) return true;
					if (window.batidaI18n.isNoValue(current)  && window.batidaI18n.isNoValue(val))  return true;
				}
				return false;
			});
		});
	}

	function findVariantBySrednicaAndNapis(srednica, napis) {
		// v63 — Caroline's catalog convention: option1 = size, option2 = inscription.
		// Match inscription via synonym detection so 'NIE' matches 'NO'/'НІ'/'NON'/'NEIN'
		// (relevant if Translate & Adapt ever localizes variant values).
		if (!product) return null;
		// v40 (2026-05-06): match the SIZE prefix only ("18cm") instead of full
		// variant value. Translate & Adapt translates Caroline's PL master
		// "18cm (≈8porcji)" to display values like "18 cm (½8 Portionen)" (DE),
		// "18 cm (≈8 portions)" (FR), etc. The size-card data-value is the
		// translated form; product.variants[].option1 is the master Polish form.
		// Strict !== comparison failed in non-Polish locales → no price rendered.
		// Extract the cm prefix from both sides and compare those instead.
		var __extractSize = function (s) {
			var m = (s || '').match(/(\d+)\s*(?:cm|см)/i);   /* Latin cm or Cyrillic см (UK) */
			return m ? m[1] + 'cm' : null;
		};
		var srednicaSize = __extractSize(srednica);
		return product.variants.find(function (v) {
			if (srednica) {
				var vSize = __extractSize(v.option1);
				if (!srednicaSize || !vSize || srednicaSize !== vSize) return false;
			}
			if (!napis) return true;
			if (v.option2 === napis) return true;
			if (window.batidaI18n) {
				if (window.batidaI18n.isYesValue(napis) && window.batidaI18n.isYesValue(v.option2)) return true;
				if (window.batidaI18n.isNoValue(napis)  && window.batidaI18n.isNoValue(v.option2))  return true;
			}
			return false;
		});
	}

	// 29.09 (Aleksandra): every price "155,00 zł" - grosze always, lowercase "zł" (the headline used to print "ZŁ").
	// window.batidaMoney = the site-wide helper (layout/theme.liquid), same output as the Liquid prices.
	function formatPriceLong(priceMinor) {
		return formatPriceShort(priceMinor);
	}
	function formatPriceShort(priceMinor) {
		// v74f (2026-05-08): always 2 decimals + comma (Polish convention).
		// Was rounding to whole zł — looked inconsistent next to addon prices
		// like "+ 7,90 zł" / "+ 10,00 zł" that show cents.
		if (window.batidaMoney) return window.batidaMoney(priceMinor);
		return (priceMinor / 100).toFixed(2).replace('.', ',') + ' zł';
	}

	// v80 (2026-05-08): addon-aware ATC button price.
	// Headline `[data-product-price]` keeps showing the variant's UNIT price.
	// ATC button `[data-button-price]` becomes the running submission total:
	//     total = variant.price × mainQty + Σ(addon.price × addon.qty)
	// for every checked .cross-product__checkbox. Reads addon prices from the
	// rendered .batida-perso-row .batida-perso-price-col (which both v29
	// dc-pc / Napis-bearing mode AND v52 bez-wariantow Addons-only mode emit
	// uniformly, with v77d's PRICE_OVERRIDES already applied for products
	// where Pipeline rendered bare titles). Works on every template uniformly
	// — dc-pc, bez-wariantow, and any future template that uses the same
	// .batida-perso-row primitive.
	function v80ParseZl(text) {
		// "+ 15,00 zł" / "15 zł" / "+ 7,90 ZŁ" → 1500 / 1500 / 790
		if (!text) return 0;
		var m = String(text).replace(/\s+/g, ' ').match(/(\d+(?:[.,]\d+)?)/);
		if (!m) return 0;
		return Math.round(parseFloat(m[1].replace(',', '.')) * 100);
	}
	function v80GetMainQty() {
		var q = document.querySelector('input[name="quantity"]');
		if (!q) return 1;
		var n = parseInt(q.value, 10);
		return (isNaN(n) || n < 1) ? 1 : n;
	}
	function v80GetAddonsTotal() {
		var rows = document.querySelectorAll('.batida-perso-row[data-handle]');
		var total = 0;
		rows.forEach(function (row) {
			var handle = row.getAttribute('data-handle');
			// Toggle state — prefer the canonical .cross-product__checkbox;
			// fall back to the visible toggle's is-on class for safety.
			var checked = false;
			var cp = document.querySelector('.cross-product[data-canonical-handle="' + handle + '"]');
			if (cp) {
				var cb = cp.querySelector('.cross-product__checkbox');
				checked = !!(cb && cb.checked);
			} else {
				var t = row.querySelector('.batida-perso-toggle');
				checked = !!(t && t.classList.contains('is-on'));
			}
			if (!checked) return;
			var priceCol = row.querySelector('.batida-perso-price-col');
			var price = v80ParseZl(priceCol ? priceCol.textContent : '');
			if (!price) return;
			// Addon qty: visible number stepper (e.g. Talerz drewniany) or default 1.
			// Hidden qty inputs default to 1 because Pipeline always sets value="1"
			// on those (e.g. napisz-swoj-list, swieczka-cyferka).
			var qty = 1;
			var exp = row.nextElementSibling && row.nextElementSibling.classList.contains('batida-perso-expanded')
				? row.nextElementSibling : null;
			if (exp) {
				// 24.09 audit: the v2 card's stepper keeps its quantity in a hidden input
				var qInput = exp.querySelector('.cross-product__input[type="number"], .cross-product__input[type="hidden"]');
				if (qInput) {
					var n = parseInt(qInput.value, 10);
					if (!isNaN(n) && n > 0) qty = n;
				}
			}
			total += price * qty;
		});
		return total;
	}
	function v80UpdateAtcButton(v) {
		if (!v) v = findVariantForCurrent();
		if (!v) return;
		var atc = v.price * v80GetMainQty() + v80GetAddonsTotal();
		document.querySelectorAll('[data-button-price]').forEach(function (el) {
			el.textContent = formatPriceShort(atc);
		});
	}

	function updateDisplayedPrice() {
		var v = findVariantForCurrent();
		if (!v) return null;
		// Headline: variant UNIT price (always — never multiplied / never +addons).
		var formatted = formatPriceLong(v.price);
		document.querySelectorAll('[data-product-price]').forEach(function (el) { el.textContent = formatted; });
		// ATC button: running submission total (v80).
		v80UpdateAtcButton(v);
		// Sync Alpine state too so add-to-cart submits the right variant id
		var alpineRoot = document.querySelector('[x-data="productForm()"]');
		if (alpineRoot && alpineRoot._x_dataStack && alpineRoot._x_dataStack[0]) {
			alpineRoot._x_dataStack[0].variantId = v.id;
		}
		return v;
	}

	// v80 listener binding — uses event delegation so it works regardless of
	// when rows / checkboxes / qty inputs mount (v29 + v52 both build async).
	function v80BindAddonListeners() {
		if (window.__batidaV80Bound) return;
		window.__batidaV80Bound = true;
		var debounce;
		function scheduleRecompute(delay) {
			clearTimeout(debounce);
			debounce = setTimeout(v80UpdateAtcButton, delay || 30);
		}
		// Toggle clicks (the visible button — fires BEFORE the underlying checkbox
		// state mutation in our handler, so we delay slightly more than the change event).
		document.addEventListener('click', function (e) {
			if (e.target && e.target.closest && e.target.closest('.batida-perso-toggle')) {
				scheduleRecompute(60);
			}
		}, true);
		// Underlying cross-product checkbox change (covers programmatic clicks
		// from v29/v52 dispatch + any direct user toggle of the native checkbox).
		document.addEventListener('change', function (e) {
			var t = e.target;
			if (!t || !t.classList) return;
			if (t.classList.contains('cross-product__checkbox')) scheduleRecompute(20);
			else if (t.classList.contains('cross-product__input')) scheduleRecompute(20);
			else if (t.getAttribute && t.getAttribute('name') === 'quantity') scheduleRecompute(20);
		}, true);
		// Qty stepper +/- (Pipeline + our v42b stepper both dispatch 'input').
		document.addEventListener('input', function (e) {
			var t = e.target;
			if (!t) return;
			if (t.getAttribute && t.getAttribute('name') === 'quantity') scheduleRecompute(20);
			else if (t.classList && t.classList.contains('cross-product__input')) scheduleRecompute(20);
		}, true);
	}

	function renderPricesOnCards() {
		if (!product) return;
		var cards = document.querySelectorAll('.batida-size-card');
		if (!cards.length) return;
		// Prefer NAPIS=NIE for the base price display (cheaper option)
		var sizes = [];
		cards.forEach(function (card) {
			var val = card.getAttribute('data-value');
			var v = findVariantBySrednicaAndNapis(val, 'NIE') || findVariantBySrednicaAndNapis(val, null);
			if (v) sizes.push({ card: card, price: v.price, value: val });
		});
		if (!sizes.length) return;
		var basePrice = Math.min.apply(null, sizes.map(function (s) { return s.price; }));
		sizes.forEach(function (s) {
			// Skip if price already rendered (idempotent)
			if (s.card.querySelector('.bsc-price-v18')) return;
			var priceEl = document.createElement('span');
			priceEl.className = 'bsc-price bsc-price-v18';
			priceEl.textContent = formatPriceShort(s.price);
			s.card.appendChild(priceEl);
			// Upcharge label for non-base sizes
			if (s.price > basePrice) {
				var delta = s.price - basePrice;
				var upcharge = document.createElement('span');
				upcharge.className = 'bsc-upcharge';
				upcharge.textContent = '+ ' + formatPriceShort(delta);
				s.card.appendChild(upcharge);
			}
		});
	}

	function bindHandlers() {
		// Size cards
		document.querySelectorAll('.batida-size-card').forEach(function (card) {
			if (card.getAttribute('data-v18-bound') === '1') return;
			card.setAttribute('data-v18-bound', '1');
			// Append our updater AFTER v12's click handler runs
			card.addEventListener('click', function () {
				setTimeout(updateDisplayedPrice, 50);
			});
		});
		// NAPIS toggle row
		var napisRow = document.querySelector('.batida-addon-row[data-napis-row]');
		if (napisRow && napisRow.getAttribute('data-v18-bound') !== '1') {
			napisRow.setAttribute('data-v18-bound', '1');
			napisRow.addEventListener('click', function () {
				setTimeout(updateDisplayedPrice, 100);
			});
		}
		// Also watch radio changes directly (in case user uses keyboard/screen reader)
		// v63 — find inscription radios via helper, language-agnostic
		var inscriptionWrap = window.batidaI18n && window.batidaI18n.findInscriptionWrapper();
		var radios = inscriptionWrap
			? inscriptionWrap.querySelectorAll('input[type="radio"]')
			: document.querySelectorAll('[data-select-label="NAPIS"] input[type="radio"]');
		radios.forEach(function (r) {
			if (r.getAttribute('data-v18-bound') === '1') return;
			r.setAttribute('data-v18-bound', '1');
			r.addEventListener('change', function () { setTimeout(updateDisplayedPrice, 50); });
		});
		// v81 (2026-05-08): bind change listeners on EVERY variant-option radio,
		// not just inscription. od-15-porcji template uses v71's shape + servings
		// configurator — clicking a shape card or serving button forwards to
		// Pipeline's underlying radio.click(), but updateDisplayedPrice was only
		// hooked on .batida-size-card clicks + inscription radios. Result: shape
		// or serving change fired the radio but headline + ATC stayed at the
		// initial variant's price. Generalized: listen on all .selector-wrapper
		// radios. updateDisplayedPrice is idempotent, so doubling up with the
		// inscription handler above is harmless. Also fires v80UpdateAtcButton
		// because updateDisplayedPrice calls it.
		document.querySelectorAll('.selector-wrapper input[type="radio"]').forEach(function (r) {
			if (r.getAttribute('data-v81-bound') === '1') return;
			r.setAttribute('data-v81-bound', '1');
			r.addEventListener('change', function () { setTimeout(updateDisplayedPrice, 50); });
		});
		// v82 (2026-05-08): document-level delegation for ANY input change inside
		// a .selector-wrapper. v81's `[type="radio"]` selector missed Pipeline's
		// popout-select picker on artystyczne products (Flower-power et al.) —
		// the popout uses `<input class="select-popout__input--*">` without
		// type="radio", so the radio-only selector didn't bind. Result: porcji
		// change on Flower-power didn't update headline OR ATC even though
		// the variant DID change in Pipeline's form state. Delegation fires
		// on any input/select change that bubbles up from a .selector-wrapper —
		// covers radio, popout-input, hidden, native <select>, future picker
		// types alike. Bound once globally via window flag.
		if (!window.__batidaV82VariantBound) {
			window.__batidaV82VariantBound = true;
			document.addEventListener('change', function (e) {
				if (e.target && e.target.closest && e.target.closest('.selector-wrapper')) {
					setTimeout(updateDisplayedPrice, 50);
				}
			}, true);
		}
	}

	function init() {
		fetchProduct().then(function (p) {
			if (!p) return;
			product = p;
			renderPricesOnCards();
			bindHandlers();
			v80BindAddonListeners(); // v80 — addon-aware ATC price (one-time global delegation)
			updateDisplayedPrice(); // sync to current selection on load
			// Re-bind a few times in case v12 cards mount late
			setTimeout(function () { renderPricesOnCards(); bindHandlers(); v80UpdateAtcButton(); }, 800);
			setTimeout(function () { renderPricesOnCards(); bindHandlers(); v80UpdateAtcButton(); }, 2000);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


/* =====================================================================
   v20 — NAPIS variant normalization (Pat 2026-05-03)
   Replaces v12's exact-match napis wrapper finder with a fuzzy match
   that catches Caroline's 8+ catalog naming variations:
     Napis, NAPIS, Napis*, Tabliczka z napisem*, Napis na torcie,
     Napis na torcie*, Nappis na torcie (typo)
   Re-renders the Dodatki toggle for products my v12 missed.
   ===================================================================== */

(function v20NapisNormalizer() {
	function isNapisLabel(label) {
		if (!label) return false;
		var l = label.toLowerCase();
		// v63 — Polish synonyms PLUS English/UK/FR/DE inscription terms
		return l.indexOf('napis') !== -1 || l.indexOf('nappis') !== -1 || l.indexOf('tabliczka') !== -1
			|| l.indexOf('inscription') !== -1 || l.indexOf('напис') !== -1
			|| l.indexOf('inschrift') !== -1 || l.indexOf('beschriftung') !== -1;
	}

	function findNapisWrapper() {
		// v63 — prefer the language-agnostic helper (uses .radio__button-input--inscription
		// class, which Pipeline emits for every "cake text"-tagged product regardless of locale)
		if (window.batidaI18n) {
			var w = window.batidaI18n.findInscriptionWrapper();
			if (w) return w;
		}
		// Fallback: legacy text-label match (now extended for 5 langs)
		var wrappers = document.querySelectorAll('.selector-wrapper[data-select-label]');
		for (var i = 0; i < wrappers.length; i++) {
			if (isNapisLabel(wrappers[i].getAttribute('data-select-label'))) {
				return wrappers[i];
			}
		}
		return null;
	}

	function findRadioByValue(wrapper, valueLowerOptions) {
		// v63 — defer to batidaI18n synonyms when matching standard yes/no
		if (window.batidaI18n && valueLowerOptions.length > 0) {
			var first = valueLowerOptions[0];
			if (window.batidaI18n.isYesValue(first)) return window.batidaI18n.findYesRadio(wrapper);
			if (window.batidaI18n.isNoValue(first))  return window.batidaI18n.findNoRadio(wrapper);
		}
		var radios = wrapper.querySelectorAll('input[type="radio"]');
		for (var i = 0; i < radios.length; i++) {
			var v = (radios[i].value || '').toLowerCase().trim();
			if (valueLowerOptions.indexOf(v) !== -1) return radios[i];
		}
		return null;
	}

	function init() {
		var wrapper = findNapisWrapper();
		if (!wrapper) return;
		// Don't double-render if v12 already injected for this product
		if (document.querySelector('[data-perso-v2]')) return; /* BS-32 v2 guard */ if (document.querySelector('.batida-addon-section[data-from="napis"]')) return;

		// v63 — yes/no radios via helpers (covers TAK/YES/ТАК/OUI/JA + NIE/NO/НІ/NON/NEIN)
		var nieRadio = window.batidaI18n ? window.batidaI18n.findNoRadio(wrapper) : findRadioByValue(wrapper, ['nie', 'no']);
		var takRadio = window.batidaI18n ? window.batidaI18n.findYesRadio(wrapper) : findRadioByValue(wrapper, ['tak', 'yes']);
		if (!nieRadio || !takRadio) return;

		// Compute price delta dynamically from product variants if possible
		var priceDelta = '+ 10,00 zł'; // v62/v74f: catalog-wide actual delta

		// Build the Dodatki section
		var section = document.createElement('div');
		section.className = 'batida-addon-section';
		section.setAttribute('data-from', 'napis');
		// v75 (2026-05-08): napis title/subtitle from window.batidaT bridge.
		var __napisTitle2 = window.batidaT('napis.title', 'Napis na torcie');
		var __napisSubtitle2 = window.batidaT('napis.subtitle', 'Ręcznie pisany');
		section.innerHTML =
			'<p class="batida-addon-section__label">Dodatki do tortu</p>' +
			'<div class="batida-addon-row" data-napis-row>' +
				'<div class="batida-addon-row__text">' + __napisTitle2 + '<small>' + __napisSubtitle2 + ' · ' + priceDelta + '</small></div>' +
				'<div class="batida-addon-toggle"></div>' +
			'</div>';

		// v82d (2026-05-08): place section AFTER the inscription wrapper (last
		// option position) so Personalizacja renders at the end of the variant
		// block — `Ilość Porcji → Smak → Personalizacja` on artystyczne. See
		// matching change in v12NapisToggle (~line 1206) for the rationale.
		wrapper.parentNode.insertBefore(section, wrapper.nextSibling);

		// Initial toggle state from current radio
		var row = section.querySelector('[data-napis-row]');
		if (takRadio.checked) row.classList.add('is-on');

		// Find litem container (cake-text JS injection target)
		var litem = document.querySelector('.line-item-property__field.litem');

		function applyState(on) {
			row.classList.toggle('is-on', on);
			if (on) {
				takRadio.checked = true;
				takRadio.dispatchEvent(new Event('change', { bubbles: true }));
				if (litem) litem.removeAttribute('hidden');
			} else {
				nieRadio.checked = true;
				nieRadio.dispatchEvent(new Event('change', { bubbles: true }));
				if (litem) litem.setAttribute('hidden', '');
			}
		}

		row.addEventListener('click', function () {
			applyState(!row.classList.contains('is-on'));
		});

		// Sync if radio changes from outside
		[nieRadio, takRadio].forEach(function (r) {
			r.addEventListener('change', function () {
				row.classList.toggle('is-on', takRadio.checked);
				if (litem) {
					if (takRadio.checked) litem.removeAttribute('hidden');
					else litem.setAttribute('hidden', '');
				}
			});
		});
	}

	function initLater() {
		init();
		setTimeout(init, 600);
		setTimeout(init, 1500);
		setTimeout(init, 3000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLater);
	} else {
		initLater();
	}
})();


/* =====================================================================
   v21 — PDP redesign behaviors (Pat 2026-05-03)
   - Inject ROZMIAR label above size cards
   - Rename "Dodatki do tortu" → "Personalizacja"
   - Update Napis subtitle copy
   - Restructure addon rows: extract "+ XX zł" from labels, right-align as separate price element
   - Add subtitle copy to cross-products by handle
   - Wrap quantity + ATC into a flex row
   - Append "→" arrow to ATC button text
   ===================================================================== */

(function v21Redesign() {
	// v75 (2026-05-08): subtitles sourced from window.batidaT bridge → locales/pl.json.
	// Keep canonical Shopify HANDLES (with hyphens) as lookup keys — they're routing keys
	// used by callsites (cart drawer routing, cross-product lookup), NOT translatable.
	var SUBTITLES = {
		'napisz-swoj-list': window.batidaT('perso.subtitle_napisz_swoj_list', 'Drukowany na papierze czerpanym'),
		'swieczka-cyferka': window.batidaT('perso.subtitle_swieczka_cyferka', 'Wybierz cyfrę poniżej'),
		'swieczki-dlugie':  window.batidaT('perso.subtitle_swieczki_dlugie',  'Klasyczne, biało-złote'),
		'swieczki-male':    window.batidaT('perso.subtitle_swieczki_dlugie',  'Klasyczne, biało-złote'),
		'bilecik':          window.batidaT('perso.subtitle_bilecik',          'Mała karta z wiadomością'),
		'talerz':           window.batidaT('perso.subtitle_zestaw_jednorazowy', 'Drewniane, ekologiczne'),
		'sztucce':          window.batidaT('perso.subtitle_zestaw_jednorazowy', 'Drewniane, ekologiczne'),
		'zestaw-jednorazowy': window.batidaT('perso.subtitle_zestaw_jednorazowy', 'Drewniane, ekologiczne')
	};

	function addRozmiarLabel() {
		var cards = document.querySelector('.batida-size-cards');
		if (!cards) return;
		var prev = cards.previousElementSibling;
		if (prev && prev.classList.contains('batida-section-label')) return;
		var label = document.createElement('p');
		label.className = 'batida-section-label batida-section-label--rozmiar';
		label.textContent = window.batidaT('size_cards.label', 'Rozmiar');
		cards.parentNode.insertBefore(label, cards);
	}

	function renameDodatki() {
		// v63 — find by structure (the addon-section we built has data-from="napis"); rename
		// regardless of current label text, since "Dodatki do tortu" only matches in Polish.
		// v75 — section_title fallback is the new Caroline-approved wording.
		var label = document.querySelector('.batida-addon-section[data-from="napis"] .batida-addon-section__label');
		var newTitle = window.batidaT('perso.section_title', 'Personalizacja / Dodatki');
		if (label && label.textContent !== newTitle) {
			label.textContent = newTitle;
		}
	}

	function upgradeNapisSubtitle() {
		var small = document.querySelector('.batida-addon-row[data-napis-row] .batida-addon-row__text small');
		if (small) {
			// Strip the "+ XX zł" from the subtitle if present (price now lives separately)
			small.textContent = window.batidaT('napis.subtitle', 'Ręcznie pisany');
		}
	}

	function extractNapisPriceToOwnElement() {
		var row = document.querySelector('.batida-addon-row[data-napis-row]');
		if (!row || row.querySelector('.batida-addon-row__price')) return;
		// v62 — Napis upcharge is uniformly +10 zł across the entire cake
		// catalog (verified across Duet, Mus, Miłości, Red Velvet, Beza,
		// Sernik mango). v49 may overwrite this with a per-product variant
		// delta, but the static fallback should match reality.
		var price = document.createElement('span');
		price.className = 'batida-addon-row__price';
		price.textContent = '+ 10,00 zł';  // v74f: 2 decimals to match other addon rows
		var toggle = row.querySelector('.batida-addon-toggle');
		if (toggle) row.insertBefore(price, toggle);
	}

	function restructureCrossProducts() {
		/* BS-32: skip legacy perso surgery when the v2 SSR card is present */ if (document.querySelector('[data-perso-v2]')) return;
		var rows = document.querySelectorAll('.batida-addon-section[data-from="napis"] .cross-product');
		rows.forEach(function (row) {
			var label = row.querySelector('label > span');
			if (!label || row.getAttribute('data-v21-restructured') === '1') return;

			// Parse the label text: "Title + 15,00 zł" → title + price
			var raw = label.textContent.trim();
			var match = raw.match(/^(.*?)\s*\+\s*([\d.,]+)\s*z[lł]\.?$/i);

			var title, priceText;
			if (match) {
				title = match[1].trim();
				priceText = '+ ' + match[2].trim() + ' zł';
			} else {
				title = raw;
				priceText = null;
			}

			// Get subtitle from handle (the .cross-product--{handle} class)
			var handle = '';
			(row.className || '').split(/\s+/).forEach(function (cls) {
				var m = cls.match(/^cross-product--(.+)$/);
				if (m) handle = m[1];
			});
			// v8 (2026-05-06): T Lab translates Pipeline's title|handle slug per locale
			// (e.g. cross-product--napisz-swoj-list → cross-product--blatt in DE).
			// Normalize to canonical Polish handle by detecting input field presence,
			// since field name + class are server-side and language-independent.
			if (row.querySelector('textarea[name="properties[_Message-Wiadomosc]"]')) handle = 'napisz-swoj-list';
			else if (row.querySelector('.cross-product__input-text--candles')) handle = 'swieczka-cyferka';
			var subtitle = SUBTITLES[handle] || '';

			// v62 — override the Liquid-baked price with the actual Shopify
			// product price for known addon products. The previous developer
			// baked "+ 10,00 zł" into the cross-product Liquid for everything,
			// but the linked products are priced differently in Shopify:
			//   - napisz-swoj-list  → 15,00 PLN (single variant)
			//   - swieczka-cyferka  → 7,90 PLN  (uniform across digits 0-9)
			// Update this map if a linked product's price changes in Shopify.
			var PRICE_OVERRIDES = {
				'napisz-swoj-list': '+ 15,00 zł',  // v74f: 2 decimals
				'swieczka-cyferka': '+ 7,90 zł'
			};
			if (PRICE_OVERRIDES[handle]) priceText = PRICE_OVERRIDES[handle];

			// Replace label content with title + subtitle
			label.innerHTML = title + (subtitle ? '<small class="cross-product-subtitle">' + subtitle + '</small>' : '');

			// Add right-aligned price BEFORE the switcher
			if (priceText) {
				var priceSpan = document.createElement('span');
				priceSpan.className = 'cross-product-price';
				priceSpan.textContent = priceText;
				var switcher = row.querySelector('.cross-product__switcher');
				if (switcher && switcher.parentElement) {
					switcher.parentElement.insertBefore(priceSpan, switcher);
				}
			}

			row.setAttribute('data-v21-restructured', '1');
		});
	}

	function inlineQtyAtc() {
		var qty = document.querySelector('.product__block__quantity');
		var btns = document.querySelector('.product__block__buttons');
		if (!qty || !btns) return;
		if (document.querySelector('.batida-qty-atc-row')) return;

		var wrapper = document.createElement('div');
		wrapper.className = 'batida-qty-atc-row product__block';
		// Insert wrapper at btns position to preserve flow
		btns.parentNode.insertBefore(wrapper, btns);
		wrapper.appendChild(qty);
		wrapper.appendChild(btns);
	}

	function addAtcArrow() {
		// v74f (2026-05-08): no-op — Pat asked to remove the arrow from ATC button.
		// Also remove any existing arrow (if older deploy injected one and the
		// node is still in the DOM after our setInterval re-init).
		var btn = document.querySelector('.btn--add-to-cart');
		if (!btn) return;
		var existing = btn.querySelector('.batida-atc-arrow');
		if (existing) existing.remove();
	}

	function init() {
		addRozmiarLabel();
		renameDodatki();
		upgradeNapisSubtitle();
		extractNapisPriceToOwnElement();
		restructureCrossProducts();
		inlineQtyAtc();
		addAtcArrow();
	}

	function initLater() {
		init();
		setTimeout(init, 600);
		setTimeout(init, 1500);
		setTimeout(init, 3000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLater);
	} else {
		initLater();
	}
})();


/* =====================================================================
   v22 — PDP layout defensive rescue (Pat 2026-05-03)
   Some race condition in v14/v21 init order caused the
   .product__block__quantity to end up as a child of the Dodatki
   section instead of in the bottom .batida-qty-atc-row wrapper.
   Root cause not pinned down, but symptom: qty stepper rendered
   between Napis row and cross-products inside the Personalizacja card.
   v22 defensively monitors qty's parent and forces it back into the
   wrapper if it's anywhere else.
   ===================================================================== */

(function v22QtyRescue() {

	function ensureQtyInWrapper() {
		var qty = document.querySelector('.product__block__quantity');
		var wrapper = document.querySelector('.batida-qty-atc-row');
		var btns = document.querySelector('.product__block__buttons');
		if (!qty || !wrapper || !btns) return;
		// If qty is already a direct child of the wrapper, nothing to do
		if (qty.parentElement === wrapper) return;
		// Otherwise, move it back into the wrapper before btns
		wrapper.insertBefore(qty, btns);
	}

	function init() {
		ensureQtyInWrapper();
	}

	function initLater() {
		init();
		// Run on multiple intervals to catch any later move
		setTimeout(init, 500);
		setTimeout(init, 1000);
		setTimeout(init, 2000);
		setTimeout(init, 4000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLater);
	} else {
		initLater();
	}

	// Also use a MutationObserver on Dodatki to catch any qty insertion
	function startObserver() {
		var dodatki = document.querySelector('.batida-addon-section[data-from="napis"]');
		if (!dodatki) {
			// 24.09 audit: stop after ~10 s instead of polling forever
			startObserver.tries = (startObserver.tries || 0) + 1;
			if (startObserver.tries <= 20) setTimeout(startObserver, 500);
			return;
		}
		var observer = new MutationObserver(function () {
			// If qty appears as a direct child of Dodatki, rescue it
			var qtyInDodatki = dodatki.querySelector(':scope > .product__block__quantity');
			if (qtyInDodatki) {
				ensureQtyInWrapper();
			}
		});
		observer.observe(dodatki, { childList: true });
	}
	startObserver();
})();


/* =====================================================================
   v23 — Move Personalizacja label OUT of bordered card (Pat 2026-05-03)
   ===================================================================== */

(function v23LabelMover() {
	function moveLabelOut() {
		var dodatki = document.querySelector('.batida-addon-section[data-from="napis"]');
		if (!dodatki) return;
		var label = dodatki.querySelector('.batida-addon-section__label');
		if (!label) return;
		// If label is still inside the card, move it to be the previous sibling
		if (label.parentElement === dodatki) {
			dodatki.parentElement.insertBefore(label, dodatki);
			label.classList.add('batida-section-label');
		}
	}

	function init() {
		moveLabelOut();
	}

	function initLater() {
		init();
		setTimeout(init, 500);
		setTimeout(init, 1500);
		setTimeout(init, 3000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLater);
	} else {
		initLater();
	}
})();


/* =====================================================================
   v24 — Move .view_product info icons next to title text inside label
   (was rendering below the row, awkwardly left-aligned)
   ===================================================================== */

(function v24InlineInfoIcons() {
	function moveIcons() {
		var crosses = document.querySelectorAll('.batida-addon-section[data-from="napis"] .cross-product');
		crosses.forEach(function (row) {
			var view = row.querySelector('.view_product');
			if (!view) return;
			// Find the title span (excluding price + switcher)
			var titleSpan = Array.from(row.querySelectorAll('label > span')).find(function (s) {
				return !s.classList.contains('cross-product-price') && !s.classList.contains('cross-product__switcher');
			});
			if (!titleSpan) return;
			// Don't re-move if already inside titleSpan
			if (view.parentElement === titleSpan) return;
			// Insert before subtitle if present, else append
			var subtitle = titleSpan.querySelector('.cross-product-subtitle');
			if (subtitle) {
				titleSpan.insertBefore(view, subtitle);
			} else {
				titleSpan.appendChild(view);
			}
		});
	}

	function init() {
		moveIcons();
	}

	function initLater() {
		init();
		setTimeout(init, 600);
		setTimeout(init, 1500);
		setTimeout(init, 3000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLater);
	} else {
		initLater();
	}
})();


/* =====================================================================
   v29 — Personalizacja section rebuild (Pat 2026-05-04)
   Replaces the layered v21-v28 markup (mix of .batida-addon-row and
   .cross-product) with a single unified .batida-perso-row component
   styled by CSS Grid. Reads existing data from legacy DOM, builds new
   markup, hides legacy elements (preserving underlying inputs/checkboxes
   for form submission), wires new toggles to underlying inputs.
   ===================================================================== */

(function v29PersoRebuild() {
	// v75 (2026-05-08): subtitles sourced from window.batidaT bridge → locales/pl.json.
	var SUBTITLES = {
		'napisz-swoj-list': window.batidaT('perso.subtitle_napisz_swoj_list', 'Drukowany na papierze czerpanym'),
		'swieczka-cyferka': window.batidaT('perso.subtitle_swieczka_cyferka', 'Wybierz cyfrę poniżej'),
		'swieczki-dlugie':  window.batidaT('perso.subtitle_swieczki_dlugie',  'Klasyczne, biało-złote'),
		'bilecik':          window.batidaT('perso.subtitle_bilecik',          'Mała karta z wiadomością'),
		// v37 (2026-05-06): canonical handle is 'zestaw-jednorazowy', not 'talerz'
		// (the latter doesn't exist as a Shopify product slug — fetchProduct 404'd).
		'zestaw-jednorazowy': window.batidaT('perso.subtitle_zestaw_jednorazowy', 'Drewniane, ekologiczne')
	};
	var INFO_HANDLES = ['napisz-swoj-list', 'swieczka-cyferka', 'swieczki-dlugie', 'bilecik', 'zestaw-jednorazowy'];

	// v36 (2026-05-06): localized handle → canonical Polish handle. Shopify's T Lab
	// translates handles per locale (DE shown below). Input-field detection only
	// works for napisz-swoj-list (textarea) and swieczka-cyferka (candles input);
	// the rest need explicit mapping. Add EN/UK/FR rows here as Caroline ships
	// translations — leave the canonical PL handles in place as identity entries.
	var LOCALIZED_HANDLES = {
		// Polish (canonical, identity)
		'napisz-swoj-list': 'napisz-swoj-list',
		'swieczka-cyferka': 'swieczka-cyferka',
		'swieczki-dlugie': 'swieczki-dlugie',
		'zestaw-jednorazowy': 'zestaw-jednorazowy',
		'bilecik': 'bilecik',
		// German
		'blatt': 'napisz-swoj-list',
		'kerzencit': 'swieczka-cyferka',
		'lange-kerzen': 'swieczki-dlugie',
		'holzplatte-und-besteck': 'zestaw-jednorazowy',
		// English (verified 2026-05-07 via /en/products/love DOM inspection)
		'sheet': 'napisz-swoj-list',
		'long-candles': 'swieczki-dlugie',
		'number-candle': 'swieczka-cyferka',
		'wooden-plate-and-cutlery': 'zestaw-jednorazowy',
		// Ukrainian (verified 2026-05-07 via /uk/products/love DOM inspection)
		'примітка-1': 'napisz-swoj-list',
		'довгі-свічки': 'swieczki-dlugie',
		'candle-cit-1': 'swieczka-cyferka',
		'тарілка-та-екологічні-столові-прилади': 'zestaw-jednorazowy',
		// French (verified 2026-05-07 via /fr/products/love DOM inspection)
		'note-1': 'napisz-swoj-list',
		'bougies-longues': 'swieczki-dlugie',
		'bougie-citation': 'swieczka-cyferka',
		'plaque-et-couverts-ecologiques': 'zestaw-jednorazowy'
	};

	function canonicalize(handle, cp) {
		if (LOCALIZED_HANDLES[handle]) return LOCALIZED_HANDLES[handle];
		// Safety net: input-field detection (works regardless of locale)
		if (cp) {
			if (cp.querySelector && cp.querySelector('textarea[name="properties[_Message-Wiadomosc]"]')) return 'napisz-swoj-list';
			if (cp.querySelector && cp.querySelector('.cross-product__input-text--candles')) return 'swieczka-cyferka';
		}
		return handle;
	}

	function svgInfo() {
		/* 29.09: Batida 'info' icon when the set is loaded (snippets/batida-icons-js.liquid) */
		if (window.batidaIcon && window.batidaIcon('info')) return ' ' + window.batidaIcon('info').replace('class="bi bi--info"', 'class="bi bi--info batida-perso-info" data-v34-info="1"');
		return ' <svg class="batida-perso-info" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><line x1="12" y1="11" x2="12" y2="16"/><circle cx="12" cy="8" r="0.5" fill="currentColor"/></svg>';
	}

	function makeRow(opts) {
		var row = document.createElement('div');
		row.className = 'batida-perso-row';
		var titleHTML = opts.title + (opts.hasIcon ? svgInfo() : '');
		var subtitleHTML = opts.subtitle ? '<p class="batida-perso-subtitle">' + opts.subtitle + '</p>' : '';
		row.innerHTML =
			'<div class="batida-perso-title-col"><p class="batida-perso-title">' + titleHTML + '</p>' + subtitleHTML + '</div>' +
			'<div class="batida-perso-price-col">' + opts.price + '</div>' +
			'<div class="batida-perso-toggle-col"><button type="button" class="batida-perso-toggle' + (opts.isOn ? ' is-on' : '') + '" aria-pressed="' + (opts.isOn ? 'true' : 'false') + '"><span class="dot"></span></button></div>';
		return row;
	}

	function findNapisWrapper() {
		// v63 — language-agnostic: prefer the inscription radio class, fall back to label fuzzy-match
		if (window.batidaI18n) {
			var w = window.batidaI18n.findInscriptionWrapper();
			if (w) return w;
		}
		var wrappers = document.querySelectorAll('.selector-wrapper[data-select-label]');
		for (var i = 0; i < wrappers.length; i++) {
			var lbl = (wrappers[i].getAttribute('data-select-label') || '').toLowerCase();
			if (lbl.indexOf('napis') !== -1 || lbl.indexOf('nappis') !== -1 || lbl.indexOf('tabliczka') !== -1
				|| lbl.indexOf('inscription') !== -1 || lbl.indexOf('напис') !== -1
				|| lbl.indexOf('inschrift') !== -1 || lbl.indexOf('beschriftung') !== -1) return wrappers[i];
		}
		return null;
	}

	function build() {
		/* BS-32: skip legacy v29 perso build when the v2 SSR card is present */ if (document.querySelector('[data-perso-v2]')) return true;
		var dodatki = document.querySelector('.batida-addon-section[data-from="napis"]');
		if (!dodatki) return false;
		if (dodatki.classList.contains('v29-built')) return true;

		// Find Napis radios — v63 uses synonym matching (pl/en/uk/fr/de)
		var napisWrapper = findNapisWrapper();
		var nieRadio = null, takRadio = null;
		if (napisWrapper) {
			if (window.batidaI18n) {
				nieRadio = window.batidaI18n.findNoRadio(napisWrapper);
				takRadio = window.batidaI18n.findYesRadio(napisWrapper);
			} else {
				var radios = napisWrapper.querySelectorAll('input[type="radio"]');
				for (var i = 0; i < radios.length; i++) {
					var v = (radios[i].value || '').toLowerCase().trim();
					if (v === 'nie' || v === 'no') nieRadio = radios[i];
					if (v === 'tak' || v === 'yes') takRadio = radios[i];
				}
			}
		}

		var litem = document.querySelector('.line-item-property__field.litem');

		// Read cross-products data
		var crossProducts = Array.from(dodatki.querySelectorAll('.cross-product')).map(function (cp) {
			var inlinedTitlePrice = '';
			var handle = '';
			(cp.className || '').split(/\s+/).forEach(function (c) {
				var m = c.match(/^cross-product--(.+)$/);
				if (m) handle = m[1];
			});
			// v36 (2026-05-06): canonicalize via LOCALIZED_HANDLES map (covers all
			// 5 cross-products) with input-field detection as a safety net for
			// locales we haven't mapped yet. Result is always the canonical PL handle.
			handle = canonicalize(handle, cp);
			cp.setAttribute('data-canonical-handle', handle);
			var checkbox = cp.querySelector('input[type="checkbox"]');
			var titleSpanRaw = Array.from(cp.querySelectorAll('label > span')).find(function (s) {
				var c = (typeof s.className === 'string') ? s.className : '';
				return !c.includes('cross-product-price') && !c.includes('cross-product__switcher');
			});
			var titleText = '';
			if (titleSpanRaw) {
				titleText = Array.from(titleSpanRaw.childNodes).filter(function (n) { return n.nodeType === 3; }).map(function (n) { return n.textContent.trim(); }).join(' ').trim();
				// v38 (2026-05-06): Pipeline's German cross-product label inlines the
				// price ("Verbinden Schreiben Sie Ihren Brief + 15,00 ZŁ"). Strip the
				// trailing "+ price zł" so it doesn't render duplicated alongside our
				// price column. Matches +15zł / +15,00zł / + 7,90 ZŁ / + 2,00 ZŁ etc.
				// v39 (2026-05-06): also CAPTURE the matched price so we can use it
				// as priceText fallback below — for cross-products without v62
				// PRICE_OVERRIDES (lange-kerzen, holzplatte) Pipeline puts the price
				// in the title span and leaves .cross-product-price empty in DE locale.
				var __titlePriceMatch = titleText.match(/\s*\+\s*[\d.,]+\s*z[łl]\s*$/i);
				if (__titlePriceMatch) {
					inlinedTitlePrice = __titlePriceMatch[0].trim().replace(/\s+/g, ' ').toLowerCase();
				}
				titleText = titleText.replace(/\s*\+\s*[\d.,]+\s*z[łl]\s*$/i, '').trim();
			}
			var priceEl = cp.querySelector('.cross-product-price');
			var priceText = priceEl ? priceEl.textContent.trim() : '';
			// v39 (2026-05-06): fall back to inlined-title price when Pipeline's
			// price span is empty (German locale, products without v62 override).
			if (!priceText && inlinedTitlePrice) priceText = inlinedTitlePrice;
			var inputWrapper = cp.querySelector('.cross-product__input-wrapper');
			return { handle: handle, checkbox: checkbox, titleText: titleText, priceText: priceText, inputWrapper: inputWrapper };
		});

		// Don't build if data isn't ready yet (cross-product titles empty = v21 hasn't restructured yet)
		if (crossProducts.length && crossProducts.every(function (cp) { return !cp.titleText; })) return false;

		// Build new card
		var card = document.createElement('div');
		card.className = 'batida-perso-card';

		// Napis row — v62: corrected to the catalog-wide +10 zł upcharge
		// v75 (2026-05-08): title/subtitle from window.batidaT bridge.
		var napisIsOn = takRadio && takRadio.checked;
		var napisRow = makeRow({
			title: window.batidaT('napis.title', 'Napis na torcie'),
			subtitle: window.batidaT('napis.subtitle', 'Ręcznie pisany'),
			price: '+ 10,00 zł',  // v74f: 2 decimals
			hasIcon: false,
			isOn: napisIsOn
		});
		// v62 — mark as the Napis row so v49's price-rewriter only targets THIS row
		// (was bulldozing cross-product price overrides on its 400/1500/4000ms re-runs)
		napisRow.setAttribute('data-batida-napis-row', '1');
		card.appendChild(napisRow);
		var napisExp = document.createElement('div');
		napisExp.className = 'batida-perso-expanded';
		if (litem) napisExp.appendChild(litem);
		if (!napisIsOn) napisExp.setAttribute('hidden', '');
		card.appendChild(napisExp);
		napisRow.querySelector('.batida-perso-toggle').addEventListener('click', function () {
			var on = !this.classList.contains('is-on');
			this.classList.toggle('is-on', on);
			this.setAttribute('aria-pressed', on ? 'true' : 'false');
			if (on && takRadio) { takRadio.checked = true; takRadio.dispatchEvent(new Event('change', { bubbles: true })); }
			else if (nieRadio) { nieRadio.checked = true; nieRadio.dispatchEvent(new Event('change', { bubbles: true })); }
			if (on) napisExp.removeAttribute('hidden');
			else napisExp.setAttribute('hidden', '');
		});

		// Cross-product rows
		crossProducts.forEach(function (cp) {
			if (!cp.titleText) return; // skip if data not ready
			var subtitle = SUBTITLES[cp.handle] || '';
			// v36 (2026-05-06): paint an SVG icon on every cross-product row. Used to
			// be gated by INFO_HANDLES, which left rows like "Holzplatte" iconless
			// until v30 swapped in Pipeline's view_product (causing a visible style
			// flicker at +2.5s). Now: one icon, painted once, never swapped.
			var hasIcon = true;
			var isOn = cp.checkbox && cp.checkbox.checked;
			var row = makeRow({ title: cp.titleText, subtitle: subtitle, price: cp.priceText, hasIcon: hasIcon, isOn: isOn });
			// Stamp canonical handle on the row so v31's click handler can look up
			// DESCRIPTIONS / fetch the right product without re-detecting later.
			if (cp.handle) row.setAttribute('data-handle', cp.handle);
			card.appendChild(row);
			var exp = document.createElement('div');
			exp.className = 'batida-perso-expanded';
			if (cp.inputWrapper) exp.appendChild(cp.inputWrapper);
			// v42b (2026-05-06): wrap the cross-product quantity input (visible
			// number type — generic case e.g. zestaw-jednorazowy/wooden plate)
			// with a +/- stepper for cleaner UX. Hidden quantity inputs (typed
			// cross-products like napisz-swoj-list, swieczka-cyferka where qty
			// is always 1) are skipped because they have type="hidden".
			(function wrapWithStepper() {
				var qtyInput = exp.querySelector('.cross-product__input[type="number"]');
				if (!qtyInput || qtyInput.__batidaStepperWrapped) return;
				qtyInput.__batidaStepperWrapped = true;
				var stepper = document.createElement('div');
				stepper.className = 'batida-perso-stepper';
				var minus = document.createElement('button');
				minus.type = 'button';
				minus.className = 'batida-perso-stepper__btn batida-perso-stepper__btn--minus';
				minus.setAttribute('aria-label', '−');
				minus.textContent = '−';
				var plus = document.createElement('button');
				plus.type = 'button';
				plus.className = 'batida-perso-stepper__btn batida-perso-stepper__btn--plus';
				plus.setAttribute('aria-label', '+');
				plus.textContent = '+';
				qtyInput.parentNode.insertBefore(stepper, qtyInput);
				stepper.appendChild(minus);
				stepper.appendChild(qtyInput);
				stepper.appendChild(plus);
				function bump(delta) {
					var v = parseInt(qtyInput.value, 10) || 1;
					var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
					var max = parseInt(qtyInput.getAttribute('max'), 10) || 999;
					qtyInput.value = Math.max(min, Math.min(max, v + delta));
					qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
					qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
				}
				minus.addEventListener('click', function (e) { e.preventDefault(); bump(-1); });
				plus.addEventListener('click', function (e) { e.preventDefault(); bump(+1); });
			})();
			if (!isOn) exp.setAttribute('hidden', '');
			card.appendChild(exp);
			row.querySelector('.batida-perso-toggle').addEventListener('click', function () {
				var on = !this.classList.contains('is-on');
				this.classList.toggle('is-on', on);
				this.setAttribute('aria-pressed', on ? 'true' : 'false');
				if (cp.checkbox) {
					cp.checkbox.checked = on;
					cp.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
				}
				if (on) exp.removeAttribute('hidden');
				else exp.setAttribute('hidden', '');
			});
		});

		dodatki.appendChild(card);
		dodatki.classList.add('v29-built');
		return true;
	}

	var initTries = 0;
	function init() {
		// Try immediately, then poll every 50ms (no setTimeout chain delay).
		// 24.09 audit: stop after ~10 s so pages without the card don't poll forever.
		if (build()) return;
		if (++initTries > 200) return;
		setTimeout(init, 50);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


/* v30 (hover popups via Pipeline's .view_product) was disabled in v36 (2026-05-06) and removed 2.10.2026 (Astra cleanup
   CL-01): it returned before doing anything. Old code: git show 045adc1:assets/custom.js. v31 below owns the info icons. */


/* =====================================================================
   v31 — Click-to-open info modal for cross-product info icons
   (Pat 2026-05-04)
   ===================================================================== */

(function v31InfoModal() {
	// v75 (2026-05-08): info-modal descriptions sourced from window.batidaT bridge → locales/pl.json.
	var DESCRIPTIONS = {
		'napisz-swoj-list': window.batidaT('perso.info_napisz_swoj_list', 'Twoja osobista wiadomość drukowana na papierze czerpanym specjalnie wybraną czcionką w stylu odręcznego pisma, dołączona do zamówienia w eleganckiej kopercie.'),
		'swieczka-cyferka': window.batidaT('perso.info_swieczka_cyferka', 'Klasyczna woskowa świeczka w wybranej cyfrze (0–9). Wybierz cyfrę poniżej.'),
		'swieczki-dlugie':  window.batidaT('perso.info_swieczki_dlugie',  'Eleganckie złote świeczki długie, dodawane do zamówienia.'),
		'bilecik':          window.batidaT('perso.info_bilecik',          'Mała kartka z Twoją osobistą wiadomością, dołączona do zamówienia.'),
		// v37 (2026-05-06): canonical handle is 'zestaw-jednorazowy' (per Shopify slug),
		// not 'talerz'. Description text kept describing the wooden plate aspect.
		'zestaw-jednorazowy': window.batidaT('perso.info_zestaw_jednorazowy', 'Drewniany ekologiczny talerz, dodawany do zamówienia.')
	};

	var productCache = {};

	function fetchProduct(handle) {
		if (productCache[handle]) return Promise.resolve(productCache[handle]);
		// v41 (2026-05-06): use locale-aware URL — handles are localized in non-PL
		var __url = (window.batidaI18n && window.batidaI18n.productUrl) ? window.batidaI18n.productUrl(handle) : '/products/' + encodeURIComponent(handle) + '.js';
		return fetch(__url, { credentials: 'same-origin' })
			.then(function (r) { return r.json(); })
			.then(function (p) { productCache[handle] = p; return p; });
	}

	function ensureModal() {
		var m = document.getElementById('batida-perso-modal');
		if (m) return m;
		m = document.createElement('div');
		m.id = 'batida-perso-modal';
		m.className = 'batida-perso-modal-backdrop';
		m.innerHTML =
			'<div class="batida-perso-modal" role="dialog" aria-modal="true">' +
				'<button type="button" class="batida-perso-modal__close" aria-label="Zamknij">×</button>' +
				'<img class="batida-perso-modal__image" alt="" />' +
				'<p class="batida-perso-modal__title"></p>' +
				'<p class="batida-perso-modal__price"></p>' +
				'<p class="batida-perso-modal__desc"></p>' +
			'</div>';
		document.body.appendChild(m);
		// v75 (2026-05-08): localize the close button aria-label via window.batidaT bridge.
		var __closeBtn = m.querySelector('.batida-perso-modal__close');
		if (__closeBtn) __closeBtn.setAttribute('aria-label', window.batidaT('perso.modal_close', 'Zamknij'));

		function close() {
			m.classList.remove('is-open');
		}
		m.querySelector('.batida-perso-modal__close').addEventListener('click', close);
		m.addEventListener('click', function (e) { if (e.target === m) close(); });
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && m.classList.contains('is-open')) close();
		});
		return m;
	}

	function openModal(handle, priceText) {
		var m = ensureModal();
		var img = m.querySelector('.batida-perso-modal__image');
		var title = m.querySelector('.batida-perso-modal__title');
		var price = m.querySelector('.batida-perso-modal__price');
		var desc = m.querySelector('.batida-perso-modal__desc');

		title.textContent = window.batidaT('perso.modal_loading', 'Ładowanie…');
		price.textContent = priceText || '';
		desc.textContent = DESCRIPTIONS[handle] || '';
		// v37 (2026-05-06): also clear alt + visually hide the img while a new one
		// loads — otherwise a 404'd fetch leaves the broken-image icon next to the
		// previous product's alt text (e.g. "Świeczka cyferka" appearing on the
		// zestaw-jednorazowy modal because that was the last successful fetch).
		img.removeAttribute('src');
		img.alt = '';
		img.style.display = 'none';
		m.classList.add('is-open');

		fetchProduct(handle).then(function (p) {
			title.textContent = p.title || handle;
			if (p.featured_image) {
				img.src = p.featured_image;
				img.alt = p.title || '';
				img.style.display = '';
			}
		}).catch(function () {
			title.textContent = handle;
			// v37: leave img hidden on fetch failure — better than a broken-image icon
		});
	}

	function findTitleSpan(cp) {
		var spans = cp.querySelectorAll('label > span');
		for (var i = 0; i < spans.length; i++) {
			var c = (typeof spans[i].className === 'string') ? spans[i].className : '';
			if (c.indexOf('cross-product-price') === -1 && c.indexOf('cross-product__switcher') === -1) {
				return spans[i];
			}
		}
		return null;
	}

	function getCrossProductHandleByTitle(searchText) {
		var crosses = document.querySelectorAll('.cross-product');
		for (var i = 0; i < crosses.length; i++) {
			var cp = crosses[i];
			var cls = (cp.className || '').split(/\s+/).find(function (c) { return c.indexOf('cross-product--') === 0; });
			if (!cls) continue;
			var handle = cls.substring('cross-product--'.length);
			var titleSpan = findTitleSpan(cp);
			if (!titleSpan) continue;
			var cpText = Array.from(titleSpan.childNodes)
				.filter(function (n) { return n.nodeType === 3; })
				.map(function (n) { return n.textContent.trim(); })
				.join(' ').trim().toLowerCase();
			if (cpText && searchText && cpText.indexOf(searchText) !== -1) {
				// v34 (2026-05-06): prefer the canonical handle stamped on the cross-
				// product node by v29. The input-field fallbacks below stop working
				// after v29 moves the input wrappers into the row's expanded panel.
				var stamped = cp.getAttribute('data-canonical-handle');
				if (stamped) return stamped;
				// v32 (2026-05-06): T Lab translates the cross-product handle per locale
				// (e.g. 'napisz-swoj-list' -> 'blatt' in DE, 'swieczka-cyferka' -> 'kerzencit').
				// The DESCRIPTIONS map and /products/{handle}.js fetch are keyed by the canonical
				// Polish handle, so normalize by detecting the input field that's present.
				if (cp.querySelector('textarea[name="properties[_Message-Wiadomosc]"]')) return 'napisz-swoj-list';
				if (cp.querySelector('.cross-product__input-text--candles')) return 'swieczka-cyferka';
				return handle;
			}
		}
		return '';
	}

	function bindIcons() {
		var bound = 0;
		document.querySelectorAll('.batida-perso-card .batida-perso-row').forEach(function (row) {
			// Bind both .batida-perso-info (SVG) and .view_product (legacy) icons
			var icon = row.querySelector('.batida-perso-info, .view_product');
			if (!icon) return;
			if (icon.getAttribute('data-v31-bound') === '1') return;
			icon.setAttribute('data-v31-bound', '1');

			var title = row.querySelector('.batida-perso-title');
			var titleText = title
				? Array.from(title.childNodes).filter(function (n) { return n.nodeType === 3; }).map(function (n) { return n.textContent.trim(); }).join(' ').trim().toLowerCase()
				: '';

			// v34 (2026-05-06): prefer the canonical handle stamped by v29 on the row.
			// Fallback to title-text matching is kept for legacy/edge cases (rows v29
			// didn't build, e.g. on products without Napis variant where v52 ships an
			// addons-only card with a different code path).
			var handle = row.getAttribute('data-handle') || getCrossProductHandleByTitle(titleText);
			icon.setAttribute('data-handle', handle);

			var priceEl = row.querySelector('.batida-perso-price-col');
			var priceText = priceEl ? priceEl.textContent.trim() : '';

			// v35 (2026-05-06): use capture-phase + stopImmediatePropagation so we win
			// over Pipeline's legacy popup_product delegated handler (which would
			// otherwise open the "blatt" / "kerzencit" popup using the localized
			// handle baked into the icon's data-id attribute).
			icon.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
				if (handle) openModal(handle, priceText);
			}, true);
			bound++;
		});
		return bound;
	}

	function init() {
		bindIcons();
		// v35 (2026-05-06): keep watching for new icons. v30 runs at +2.5s and
		// REPLACES the SVG fallbacks with Pipeline's view_product elements; when
		// init's first call binds the SVGs and exits, v30's later swaps go
		// unbound and the legacy click handler wins. Observe the perso card so
		// every icon insertion gets a fresh bind.
		var card = document.querySelector('.batida-perso-card');
		if (card && !card.__v31Observed) {
			card.__v31Observed = true;
			try {
				new MutationObserver(function () { bindIcons(); }).observe(card, { childList: true, subtree: true });
			} catch (e) {}
		}
		// Belt-and-suspenders: poll for the first 12s in case the card mounts
		// after init runs, or in case the observer misses an attachment.
		if (!window.__v31Polling) {
			window.__v31Polling = true;
			var attempts = 0;
			var poll = setInterval(function () {
				bindIcons();
				if (++attempts > 24) clearInterval(poll);
			}, 500);
		}
	}

	function initLater() {
		// Run init early so the observer is in place before v30 fires at +2.5s
		setTimeout(init, 100);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLater);
	} else {
		initLater();
	}
})();


/* =====================================================================
   v32 — Speed-up + safety net for FOUC fix (Pat 2026-05-04)
   1. Aggressively run v29 builder ASAP (every 50ms) instead of waiting
      1500ms in setTimeout
   2. Safety net: if v29 hasn't built within 3 seconds, force-show the
      pre-hidden elements so user isn't stuck looking at empty space
      (only happens if JS chain fails)
   ===================================================================== */

(function v32SpeedUpAndSafetyNet() {
	var startTime = Date.now();
	var SAFETY_TIMEOUT_MS = 3000;

	function tryBuild() {
		var dodatki = document.querySelector('.batida-addon-section[data-from="napis"]');
		if (!dodatki) return false;
		if (dodatki.classList.contains('v29-built')) return true;
		// v29's IIFE has its own scope; we can't call it directly, but we can poke
		// it by dispatching events that v29 may be observing. Most reliable:
		// dispatch a custom event that v29 might listen for, OR just rely on
		// v29's own polling (which already runs every 500ms after init).
		return false;
	}

	function safetyNet() {
		var dodatki = document.querySelector('.batida-addon-section[data-from="napis"]');
		if (!dodatki) return;
		if (dodatki.classList.contains('v29-built')) return;
		// JS chain failed or is too slow — un-hide the legacy elements so user sees something
		var hidden = dodatki.querySelectorAll('.batida-addon-row, .cross-products, .line-item-property__field');
		hidden.forEach(function (el) {
			el.style.visibility = 'visible';
		});
		// Also un-hide the original NAPIS variant if needed
		// v63 — language-agnostic safety net: also include English/UK/FR/DE inscription labels
		var napisWraps = document.querySelectorAll(
			'.selector-wrapper[data-select-label*="napis" i],' +
			'.selector-wrapper[data-select-label*="tabliczka" i],' +
			'.selector-wrapper[data-select-label*="inscription" i],' +
			'.selector-wrapper[data-select-label*="напис" i],' +
			'.selector-wrapper[data-select-label*="inschrift" i],' +
			'.selector-wrapper[data-select-label*="beschriftung" i]'
		);
		// Plus: directly target the inscription wrapper found via helper (catches all langs)
		if (window.batidaI18n) {
			var w63 = window.batidaI18n.findInscriptionWrapper();
			if (w63 && Array.prototype.indexOf.call(napisWraps, w63) === -1) {
				napisWraps = Array.prototype.slice.call(napisWraps).concat([w63]);
			}
		}
		napisWraps.forEach(function (w) {
			w.style.visibility = 'visible';
			w.style.position = 'static';
			w.style.height = 'auto';
			w.style.pointerEvents = 'auto';
		});
		console.warn('[Batida] v29 rebuild took longer than ' + SAFETY_TIMEOUT_MS + 'ms — falling back to legacy markup.');
	}

	setTimeout(safetyNet, SAFETY_TIMEOUT_MS);
})();


/* =====================================================================
   v34 — Replace inline SVG icons with designer SVGs (Pat 2026-05-04)
   - Cake icon (size cards): replaces v12's stacked-cylinder placeholder
   - Info icon (cross-product info): replaces v29's generic ⓘ
   ===================================================================== */

(function v34IconReplace() {
	// v96 (2026-05-10): designer cake SVG replaced with new Ciasto.svg from Pat.
	// Original Ciasto.svg uses <style>.cls-1{stroke:#313131}</style> with hardcoded
	// color — converted to inline stroke="currentColor" so the icon inherits the
	// surrounding text color (cocoa on inactive cards, navy on active). Same pattern
	// as the existing INFO_SVG and QUICHE_SVG. class="bsc-icon" preserved so the
	// replaceCakeIcons() selector still finds it.
	var CAKE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 433 361.63" fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round" stroke-linejoin="round" class="bsc-icon"><path d="M90.76,84.29c-50.27,9.18-82.76,23.73-82.76,40.12,0,27.78,93.35,50.3,208.5,50.3s208.5-22.52,208.5-50.3c0-16.38-32.49-30.94-82.76-40.12"/><path d="M425,303.33c0,27.78-93.35,50.3-208.5,50.3S8,331.11,8,303.33"/><line x1="8" y1="303.33" x2="8" y2="124.41"/><line x1="425" y1="124.41" x2="425" y2="303.33"/><path d="M8,182.91c.03,18.37,13.75,37.32,36.45,45.42,22.67,8.18,46.33,2.7,59.7-10.82"/><path d="M425,182.91c-.03,18.37-13.75,37.32-36.45,45.42-22.67,8.18-46.33,2.7-59.7-10.82"/><path d="M104.14,217.51c5.32,17.73,25.3,32.86,51.8,35.54,26.5,2.75,50.21-7.89,60.55-24"/><path d="M216.5,229.05c10.34,16.11,34.06,26.75,60.55,24,26.51-2.68,46.48-17.81,51.8-35.54"/><line x1="300.56" y1="122.61" x2="300.56" y2="68.2"/><path d="M300.56,8s21.61,22.54,21.61,45.06-17.35,23.74-21.61,23.74-21.61-1.22-21.61-23.74,21.61-45.06,21.61-45.06"/><line x1="216.5" y1="122.61" x2="216.5" y2="68.2"/><path d="M216.5,8s21.61,22.54,21.61,45.06-17.35,23.74-21.61,23.74-21.61-1.22-21.61-23.74,21.61-45.06,21.61-45.06"/><line x1="132.44" y1="122.61" x2="132.44" y2="68.2"/><path d="M132.44,8s21.61,22.54,21.61,45.06-17.35,23.74-21.61,23.74-21.61-1.22-21.61-23.74,21.61-45.06,21.61-45.06"/></svg>';

	// v83 (2026-05-08): designer quiche SVG (decorative scalloped crust ring +
	// 6 filling shapes, stroke: currentColor). Used in size cards for products
	// on the `quiche` template (template_suffix = 'quiche', body class
	// `template-product-quiche`). Same archetype as dc-pc otherwise — Średnica
	// option with cm-prefix values, v12 size cards fire, v18 price update,
	// v80 addon-aware ATC. Only the icon differs.
	var QUICHE_SVG = '<svg class="bsc-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 682.667 682.667" fill="none" stroke="currentColor" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><g><defs><clipPath id="batidaQuicheClip" clipPathUnits="userSpaceOnUse"><path d="M0 512h512V0H0Z" fill="currentColor"></path></clipPath></defs><g clip-path="url(#batidaQuicheClip)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)"><path d="M0 0c-4.831-5.417-8.731-11.235-10.521-17.928C-15.953-38.255.626-62.176.626-84.216s-16.579-45.961-11.147-66.288c5.622-21.032 32.104-33.436 42.758-51.85 10.807-18.68 8.42-47.773 23.579-62.932 15.16-15.159 44.253-12.772 62.932-23.579 18.415-10.655 30.818-37.136 51.85-42.757 20.327-5.434 44.249 11.146 66.288 11.146 22.04 0 45.961-16.58 66.288-11.146 21.033 5.621 33.436 32.102 51.851 42.757 18.679 10.807 47.772 8.42 62.932 23.579 15.159 15.16 12.772 44.253 23.579 62.932 10.654 18.415 37.135 30.818 42.757 51.85 5.433 20.327-11.147 44.248-11.147 66.288s16.58 45.961 11.147 66.288c-5.622 21.032-32.104 33.437-42.757 51.851-10.808 18.68-8.42 47.772-23.58 62.931-6.13 6.13-14.539 9.391-23.615 11.816" transform="translate(19.114 340.216)"></path><path d="M0 0a48.87 48.87 0 0 0-5.447 2.69c-18.414 10.655-30.818 37.136-51.85 42.757-20.327 5.434-44.248-11.146-66.288-11.146s-45.961 16.58-66.288 11.146c-21.032-5.621-33.436-32.102-51.851-42.757-18.679-10.807-47.772-8.419-62.931-23.579-15.16-15.16-12.772-44.253-23.579-62.932-1.908-3.296-4.322-6.4-7.033-9.395" transform="translate(379.585 457.959)"></path><path d="M0 0c2.496 2.259 5.082 4.27 7.828 5.858 15.584 9.017 39.856 7.025 52.503 19.672 12.647 12.648 10.655 36.919 19.671 52.503 8.889 15.363 30.982 25.711 35.672 43.258 4.533 16.958-9.299 36.915-9.299 55.303 0 18.387 13.832 38.344 9.299 55.302-4.69 17.547-26.783 27.896-35.672 43.258-9.016 15.584-7.024 39.857-19.671 52.503-12.648 12.648-36.919 10.655-52.503 19.672-15.363 8.889-25.711 30.982-43.258 35.672-16.959 4.532-36.916-9.3-55.303-9.3-18.388 0-38.345 13.832-55.303 9.3-17.547-4.69-27.895-26.783-43.258-35.672-15.584-9.017-39.855-7.024-52.503-19.672-12.647-12.647-10.655-36.919-19.671-52.503-8.889-15.363-30.982-25.711-35.672-43.258-4.532-16.958 9.3-36.915 9.3-55.302 0-18.388-13.832-38.345-9.3-55.303 4.69-17.547 26.783-27.895 35.672-43.258 9.016-15.584 7.024-39.856 19.672-52.503 12.647-12.647 36.919-10.655 52.503-19.672 15.362-8.888 25.71-30.981 43.257-35.671 16.959-4.533 36.916 9.299 55.303 9.299 18.388 0 38.345-13.832 55.303-9.299 3.766 1.006 7.201 2.815 10.426 5.124" transform="translate(346.733 79.406)"></path><path d="M0 0c16.083 16.758 10.482 47.632 10.482 47.632s-31.675 3.704-47.758-13.053c-16.082-16.758-10.481-47.631-10.481-47.631S-16.083-16.757 0 0z" transform="translate(299.096 117.545)"></path><path d="M0 0c-14.907-13.57-17.517-38.472-17.517-38.472s29.37-12.428 49.502-.846S55.388 3.471 55.388 3.471s-8.43 3.567-19.353 5.098" transform="translate(241.002 251.773)"></path><path d="M0 0c-1.8 23.156-28.569 39.527-28.569 39.527S-52.418 18.355-50.617-4.801c1.8-23.156 28.568-39.527 28.568-39.527S1.8-23.156 0 0z" transform="translate(335.467 370.666)"></path><path d="M0 0c2.783 23.059-20.249 44.369-20.249 44.369S-47.792 28.294-50.574 5.235c-2.783-23.059 20.248-44.369 20.248-44.369S-2.783-23.059 0 0z" transform="translate(166.519 212.432)"></path><path d="M0 0c-13.795 18.686-45.171 18.39-45.171 18.39s-9.011-30.592 4.784-49.278C-26.592-49.573 4.784-49.277 4.784-49.277S13.794-18.686 0 0z" transform="translate(399.778 243.637)"></path><path d="M0 0c20.283 11.315 23.966 42.477 23.966 42.477s-29.203 12.815-49.487 1.5C-45.804 32.661-49.486 1.5-49.486 1.5S-20.283-11.315 0 0Z" transform="translate(158.992 301.294)"></path><path d="M0 0c0 9.665-7.835 17.5-17.5 17.5S-35 9.665-35 0s7.835-17.5 17.5-17.5S0-9.665 0 0Z" transform="translate(223.485 400.94)"></path><path d="M0 0c0 9.665-7.835 17.5-17.5 17.5S-35 9.665-35 0s7.835-17.5 17.5-17.5S0-9.665 0 0Z" transform="translate(208.377 137.996)"></path><path d="M0 0c0 9.665-7.835 17.5-17.5 17.5S-35 9.665-35 0c0-9.664 7.835-17.5 17.5-17.5S0-9.664 0 0Z" transform="translate(256 314.126)"></path><path d="M0 0c0 9.665-7.835 17.5-17.5 17.5S-35 9.665-35 0s7.835-17.5 17.5-17.5S0-9.665 0 0Z" transform="translate(402.986 310.782)"></path><path d="M0 0c0 9.665-7.835 17.5-17.5 17.5S-35 9.665-35 0s7.835-17.5 17.5-17.5S0-9.665 0 0Z" transform="translate(382.894 148.491)"></path></g></g></svg>';

	// v.5.8 (2026-05-17): per-card simpler cake icon for dc-pc 18cm.
	// User-uploaded Ciastomale.svg (small cake, ~10 strokes vs CAKE_SVG's
	// ~16). Used ONLY when the body is on `template-product-dc-pc` AND the
	// icon being replaced is the SMALL one (no .bsc-icon-lg class). The
	// 24cm card and all artystyczne-template cards keep the original
	// CAKE_SVG. stroke="currentColor" so it inherits cocoa/navy from the
	// surrounding card state, same as CAKE_SVG.
	var CAKE_SMALL_DC_PC_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 271.5 287.62" fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round" stroke-linejoin="round" class="bsc-icon"><path d="M58.71,114.59c-30.8,5.62-50.71,14.54-50.71,24.58,0,17.02,57.2,30.82,127.75,30.82s127.75-13.8,127.75-30.82c0-10.04-19.91-18.96-50.71-24.58"/><path d="M263.5,248.8c0,17.02-57.2,30.82-127.75,30.82s-127.75-13.8-127.75-30.82"/><line x1="8" y1="248.8" x2="8" y2="139.17"/><line x1="263.5" y1="139.17" x2="263.5" y2="248.8"/><path d="M8,175.02c.02,11.26,8.42,22.87,22.33,27.83,13.89,5.01,28.39,1.65,36.58-6.63"/><path d="M263.5,175.02c-.02,11.26-8.42,22.87-22.33,27.83-13.89,5.01-28.39,1.65-36.58-6.63"/><path d="M66.91,196.22c3.26,10.86,15.5,20.13,31.74,21.78,16.24,1.68,30.76-4.83,37.1-14.71"/><path d="M135.75,203.29c6.34,9.87,20.87,16.39,37.1,14.71,16.24-1.64,28.48-10.91,31.74-21.78"/><line x1="135.74" y1="122.61" x2="135.74" y2="68.2"/><path d="M135.74,8s21.61,22.54,21.61,45.06-17.35,23.74-21.61,23.74-21.61-1.22-21.61-23.74,21.61-45.06,21.61-45.06"/></svg>';

	// v83 (2026-05-08): pick the right size-card icon based on body class
	// or data-template-suffix attribute. Pipeline emits
	// `<body class="template-product-{suffix}" data-template-suffix="{suffix}">`
	// when product.template_suffix is set (after v83b's theme.liquid edit). So
	// a product flipped to templateSuffix="quiche" matches either signal →
	// quiche icon. Other size-card products (dc-pc Funfetti / Duet / etc.)
	// get cake icon.
	// v.5.8 (2026-05-17): also pick a simpler small-cake icon when on dc-pc
	// AND replacing the small (18cm) card icon. Pass `isLargeCard` from the
	// caller (read from the `.bsc-icon-lg` class on the icon being replaced).
	function getSizeIconSvg(isLargeCard) {
		var b = document.body;
		var isQuiche = b.classList.contains('template-product-quiche')
			|| b.getAttribute('data-template-suffix') === 'quiche';
		if (isQuiche) return QUICHE_SVG;
		var isDcPc = b.classList.contains('template-product-dc-pc')
			|| b.getAttribute('data-template-suffix') === 'dc-pc';
		if (isDcPc && !isLargeCard) return CAKE_SMALL_DC_PC_SVG;
		return CAKE_SVG;
	}

	// Designer info SVG (cleaned, fill: currentColor)
	var INFO_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M12.75 11c0-.41-.34-.75-.75-.75s-.75.34-.75.75v6c0 .41.34.75.75.75s.75-.34.75-.75z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25c-5.94 0-10.75 4.81-10.75 10.75s4.81 10.75 10.75 10.75 10.75-4.81 10.75-10.75S17.94 1.25 12 1.25zm-9.25 10.75c0-5.11 4.14-9.25 9.25-9.25s9.25 4.14 9.25 9.25-4.14 9.25-9.25 9.25-9.25-4.14-9.25-9.25z"/><circle cx="12" cy="8" r="1"/></svg>';

	function replaceCakeIcons() {
		var icons = document.querySelectorAll('.batida-size-card svg.bsc-icon, .batida-size-card svg.bsc-icon-lg');
		icons.forEach(function (oldIcon) {
			if (oldIcon.getAttribute('data-v34-cake') === '1') return;
			// v.5.8 (2026-05-17): detect large vs small card from the icon's own
			// class. v18 emits .bsc-icon-lg on the 24cm card and plain .bsc-icon
			// on the 18cm card. We pass isLargeCard so getSizeIconSvg can pick
			// the simpler dc-pc small-cake variant only on the 18cm card.
			var origClass = oldIcon.getAttribute('class') || 'bsc-icon';
			var isLargeCard = origClass.indexOf('bsc-icon-lg') !== -1;
			var wrap = document.createElement('span');
			// v83 (2026-05-08): pick CAKE or QUICHE per body class.
			// v.5.8 (2026-05-17): also pick small-cake variant for dc-pc 18cm.
			wrap.innerHTML = getSizeIconSvg(isLargeCard);
			var newIcon = wrap.firstChild;
			// Preserve original class (bsc-icon or bsc-icon bsc-icon-lg)
			newIcon.setAttribute('class', origClass);
			newIcon.setAttribute('data-v34-cake', '1');
			oldIcon.replaceWith(newIcon);
		});
	}

	function replaceInfoIcons() {
		var icons = document.querySelectorAll('.batida-perso-info');
		icons.forEach(function (oldIcon) {
			if (oldIcon.getAttribute('data-v34-info') === '1') return;
			var wrap = document.createElement('span');
			wrap.innerHTML = (window.batidaIcon && window.batidaIcon('info', 14)) || INFO_SVG; /* 29.09: Batida icon first */
			var newIcon = wrap.firstChild;
			newIcon.setAttribute('class', 'batida-perso-info');
			newIcon.setAttribute('data-v34-info', '1');
			oldIcon.replaceWith(newIcon);
		});
	}

	function init() {
		replaceCakeIcons();
		replaceInfoIcons();
	}

	function initLater() {
		init();
		// Re-run after v12 (size cards) and v29 (perso card) finish mounting
		setTimeout(init, 200);
		setTimeout(init, 800);
		setTimeout(init, 2000);
		setTimeout(init, 4000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLater);
	} else {
		initLater();
	}

	// v83 (2026-05-08): expose the per-template SVG to v18 size-card init.
	// v18 reads these once at init; Pipeline sets the body class server-side
	// before any JS runs, so the right SVG is selected on first read.
	// v.5.8 (2026-05-17): SM and LG are now distinct SVG sources on dc-pc
	// (SM = simpler Ciastomale, LG = full CAKE_SVG), so resolve them
	// separately rather than deriving LG by string-replace on SM.
	var __sizeIconBaseSm = getSizeIconSvg(false);
	var __sizeIconBaseLg = getSizeIconSvg(true);
	window.__BATIDA_V12_SIZE_ICON_SM = __sizeIconBaseSm;
	window.__BATIDA_V12_SIZE_ICON_LG = __sizeIconBaseLg.replace('class="bsc-icon"', 'class="bsc-icon bsc-icon-lg"');
})();


/* =====================================================================
   v35 — Move Najszybszy transport section title outside the card
   ===================================================================== */

(function v35TransportLabelMover() {
	function moveLabel() {
		var widget = document.querySelector('.product__block__zapiet-availability');
		if (!widget) return false;
		var titleEl = widget.querySelector('.product__block__zapiet-availability__title');
		// If we already injected a label, skip
		if (widget.previousElementSibling && widget.previousElementSibling.classList.contains('batida-transport-label')) return true;
		var labelText = (titleEl && titleEl.textContent.trim()) || window.batidaT('transport.label_fallback', 'Najszybszy transport');
		var newLabel = document.createElement('p');
		newLabel.className = 'batida-transport-label';
		newLabel.textContent = labelText;
		widget.parentNode.insertBefore(newLabel, widget);
		return true;
	}

	var initTries = 0;
	function init() {
		if (moveLabel()) return;
		if (++initTries > 50) return; // 24.09 audit: stop after ~10 s instead of polling forever
		setTimeout(init, 200);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


/* =====================================================================
   v49 — Napis price from real variant data (Pat 2026-05-04)
   v22/v29 hardcoded "+ 15 zł" as a fallback. Funfetti's actual delta
   is +10 zł (160-150 or 310-300). v49 fetches /products/{handle}.js,
   computes the TAK-NIE delta per size, picks the delta matching the
   currently-selected size, and rewrites the rendered Napis price.
   Re-runs on size change to handle products where the delta varies
   by size.
   ===================================================================== */

(function v49NapisRealDelta() {
	function formatPLN(amt) {
		// v74f (2026-05-08): always 2 decimals + comma, even for whole-zł amounts.
		// Was conditionally dropping decimals for integers (e.g. "+ 10 zł"), which
		// looked inconsistent next to "+ 7,90 zł" addons. Pat asked for unified format.
		if (window.batidaMoney) return '+ ' + window.batidaMoney(Math.round(amt * 100));
		return '+ ' + amt.toFixed(2).replace('.', ',') + ' zł';
	}

	var deltaCache = null; // bySize map cached after first fetch

	function getDeltaForSelectedSize() {
		if (!deltaCache) return null;
		var selectedCard = document.querySelector('.batida-size-card.is-selected');
		var sizeText = selectedCard ? (selectedCard.querySelector('.bsc-size') || {}).textContent : '';
		sizeText = (sizeText || '').trim();
		// Fuzzy match: "18cm" matches "18cm (≈8porcji)"
		var key = Object.keys(deltaCache).find(function (k) { return k.indexOf(sizeText) === 0; });
		if (key && deltaCache[key].NIE != null && deltaCache[key].TAK != null) {
			return (deltaCache[key].TAK - deltaCache[key].NIE) / 100;
		}
		// Fallback: any size's delta
		for (var k in deltaCache) {
			if (deltaCache[k].NIE != null && deltaCache[k].TAK != null) {
				return (deltaCache[k].TAK - deltaCache[k].NIE) / 100;
			}
		}
		return null;
	}

	function applyDelta() {
		var delta = getDeltaForSelectedSize();
		if (delta == null) return;
		var formatted = formatPLN(delta);
		// v62 — Scope to ONLY the Napis row (tagged via data-batida-napis-row by v29).
		// Previous selector grabbed all .batida-perso-price-col elements — meaning v49's
		// 400/1500/4000ms re-runs would bulldoze the v62 cross-product price overrides
		// (Napisz swój list = +15 zł, Świeczka cyferka = +7,90 zł) and reset everything
		// to the Napis delta. The data-batida-napis-row marker keeps this surgical.
		var napisRow = document.querySelector('[data-batida-napis-row="1"]');
		if (napisRow) {
			napisRow.querySelectorAll('.batida-perso-price-col, .batida-perso-price, .batida-addon-row__price').forEach(function (el) {
				if (el.textContent.indexOf('zł') !== -1) el.textContent = formatted;
			});
		}
		// Legacy v22-fallback path: the older .batida-addon-row uses [data-napis-row]
		// (different attribute, lowercase, set by v12NapisToggle). That row is unique to
		// the v22-style markup and has no cross-product siblings to clobber, so the
		// existing addon-row__price + subtitle update is safe to keep here.
		var legacyNapisRow = document.querySelector('.batida-addon-row[data-napis-row]');
		if (legacyNapisRow) {
			legacyNapisRow.querySelectorAll('.batida-addon-row__price').forEach(function (el) {
				if (el.textContent.indexOf('zł') !== -1) el.textContent = formatted;
			});
			legacyNapisRow.querySelectorAll('.batida-addon-row__text small').forEach(function (el) {
				var t = el.textContent;
				if (t.indexOf('zł') !== -1) {
					el.textContent = t.replace(/\+\s*[\d,.]+\s*zł/, formatted);
				}
			});
		}
	}

	function fetchAndApply() {
		var handle = (location.pathname.split('/products/')[1] || '').split('?')[0].split('/')[0];
		if (!handle) return;
		// v41 (2026-05-06): use locale-aware URL — handles are localized in non-PL
		var __url = (window.batidaI18n && window.batidaI18n.productUrl) ? window.batidaI18n.productUrl(handle) : '/products/' + handle + '.js';
		fetch(__url)
			.then(function (r) { return r.json(); })
			.then(function (p) {
				deltaCache = {};
				p.variants.forEach(function (v) {
					var size = v.option1;
					var napis = v.option2 || '';
					if (!size) return;
					// v63 — normalize any-language yes/no to canonical NIE/TAK keys
					var canonical = null;
					if (window.batidaI18n) {
						if (window.batidaI18n.isYesValue(napis)) canonical = 'TAK';
						else if (window.batidaI18n.isNoValue(napis)) canonical = 'NIE';
					} else {
						var u = napis.toUpperCase();
						if (u === 'NIE' || u === 'TAK') canonical = u;
					}
					if (!canonical) return;
					deltaCache[size] = deltaCache[size] || {};
					deltaCache[size][canonical] = v.price;
				});
				applyDelta();
				// Re-run a few times to outpace v29/v32 mounts
				setTimeout(applyDelta, 400);
				setTimeout(applyDelta, 1500);
				setTimeout(applyDelta, 4000);
				// Re-run on size card click so different-delta products stay correct
				document.body.addEventListener('click', function (e) {
					if (e.target.closest && e.target.closest('.batida-size-card')) {
						setTimeout(applyDelta, 50);
						setTimeout(applyDelta, 250);
					}
				}, true);
			})
			.catch(function () {});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', fetchAndApply);
	} else {
		fetchAndApply();
	}
})();


/* =====================================================================
   v52 — Personalizacja-style addons card for products without Napis
   variant (Pat 2026-05-04)
   v29 only builds the perso card if a Napis variant exists. Products
   like Quiche Lorraine (no Napis option, but with cross-products like
   "Napisz swój list" + "Talerz") fell back to V.5's legacy floating
   form box, breaking the consistent PDP design.
   v52 detects "no Napis variant + has cross-products" and:
   1. Hides the stray .line-item-property__field.litem (a cake-text
      input that v15/v16 inject without checking for Napis variant —
      meaningless on products without Napis).
   2. Hides the legacy .cross-products container.
   3. Builds a .batida-perso-card with one toggle row per cross-product,
      same styling as v29's card, with a "DODATKI" section label.
   4. Wires each toggle to the underlying checkbox so cart still works.
   ===================================================================== */

(function v52AddonsOnlyCard() {
		/* BS-32: skip legacy perso surgery when the v2 SSR card is present */ if (document.querySelector('[data-perso-v2]')) return;
	// v75 (2026-05-08): subtitles sourced from window.batidaT bridge → locales/pl.json.
	var SUBTITLES = {
		'napisz-swoj-list': window.batidaT('perso.subtitle_napisz_swoj_list', 'Drukowany na papierze czerpanym'),
		'swieczka-cyferka': window.batidaT('perso.subtitle_swieczka_cyferka', 'Wybierz cyfrę poniżej'),
		'swieczki-dlugie':  window.batidaT('perso.subtitle_swieczki_dlugie',  'Klasyczne, biało-złote'),
		'bilecik':          window.batidaT('perso.subtitle_bilecik',          'Mała karta z wiadomością'),
		'talerz':           window.batidaT('perso.subtitle_zestaw_jednorazowy', 'Drewniane, ekologiczne'),
		'zestaw-jednorazowy': window.batidaT('perso.subtitle_zestaw_jednorazowy', 'Drewniane, ekologiczne')
	};
	var INFO_HANDLES = ['napisz-swoj-list', 'swieczka-cyferka', 'swieczki-dlugie', 'bilecik', 'talerz', 'zestaw-jednorazowy'];

	// v77d (2026-05-08): same PRICE_OVERRIDES as v21 (restructureCrossProducts).
	// Pipeline's PL-locale rendering of cross-product labels doesn't always include the
	// price inline ("Napisz swój list" instead of "Napisz swój list + 15,00 zł"), so
	// label-parsing falls through and prices show empty in addons-only mode. This map
	// ensures known cross-products always have a price displayed regardless of locale.
	// Update if Caroline changes a cross-product price in Shopify admin.
	var PRICE_OVERRIDES = {
		'napisz-swoj-list':   '+ 15,00 zł',
		'swieczka-cyferka':   '+ 7,90 zł',
		'swieczki-dlugie':    '+ 10,00 zł',
		'talerz':             '+ 2,00 zł',
		'zestaw-jednorazowy': '+ 2,00 zł',
		'bilecik':            '+ 5,00 zł'
	};

	function svgInfo() {
		/* 29.09: Batida 'info' icon when the set is loaded (snippets/batida-icons-js.liquid) */
		if (window.batidaIcon && window.batidaIcon('info')) return ' ' + window.batidaIcon('info').replace('class="bi bi--info"', 'class="bi bi--info batida-perso-info" data-v34-info="1"');
		return ' <svg class="batida-perso-info" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><line x1="12" y1="11" x2="12" y2="16"/><circle cx="12" cy="8" r="0.5" fill="currentColor"/></svg>';
	}

	function findNapisWrapper() {
		// v63 — language-agnostic: prefer the inscription radio class
		if (window.batidaI18n) {
			var w = window.batidaI18n.findInscriptionWrapper();
			if (w) return w;
		}
		var wrappers = document.querySelectorAll('.selector-wrapper[data-select-label]');
		for (var i = 0; i < wrappers.length; i++) {
			var lbl = (wrappers[i].getAttribute('data-select-label') || '').toLowerCase();
			if (lbl.indexOf('napis') !== -1 || lbl.indexOf('nappis') !== -1 || lbl.indexOf('tabliczka') !== -1
				|| lbl.indexOf('inscription') !== -1 || lbl.indexOf('напис') !== -1
				|| lbl.indexOf('inschrift') !== -1 || lbl.indexOf('beschriftung') !== -1) return wrappers[i];
		}
		return null;
	}

	function build() {
		// Skip if v29 has already built (Napis-bearing products handled there)
		if (document.querySelector('.batida-addon-section[data-from="napis"].v29-built')) return true;
		// Skip if v52 has already run (idempotent)
		if (document.querySelector('.batida-addon-section[data-from="addons"]')) return true;

		// Skip products WITH Napis variant — those go through v22 + v29 path
		if (findNapisWrapper()) return true;

		// Find legacy cross-products container
		var cpContainer = document.querySelector('.cross-products');
		if (!cpContainer) return false; // not ready or product has no addons at all

		// Read cross-products data
		var crossProducts = Array.from(cpContainer.querySelectorAll('.cross-product')).map(function (cp) {
			var handle = '';
			(cp.className || '').split(/\s+/).forEach(function (c) {
				var m = c.match(/^cross-product--(.+)$/);
				if (m) handle = m[1];
			});
			// v8 (2026-05-06): normalize handle for T Lab-translated locales
			if (cp.querySelector('textarea[name="properties[_Message-Wiadomosc]"]')) handle = 'napisz-swoj-list';
			else if (cp.querySelector('.cross-product__input-text--candles')) handle = 'swieczka-cyferka';
			// v34 (2026-05-06): stamp canonical handle on the cross-product DOM node so
			// v30 (viewMap) and v31 (modal opener) can recover it later. Without this
			// they re-query input fields, but those have already been moved into the
			// expanded row panel by the time they run, so the normalization fails.
			cp.setAttribute('data-canonical-handle', handle);
			var checkbox = cp.querySelector('input[type="checkbox"]');
			var titleSpanRaw = Array.from(cp.querySelectorAll('label > span')).find(function (s) {
				var c = (typeof s.className === 'string') ? s.className : '';
				return !c.includes('cross-product-price') && !c.includes('cross-product__switcher');
			});
			var titleText = '';
			if (titleSpanRaw) {
				titleText = Array.from(titleSpanRaw.childNodes).filter(function (n) { return n.nodeType === 3; }).map(function (n) { return n.textContent.trim(); }).join(' ').trim();
				// v38 (2026-05-06): Pipeline's German cross-product label inlines the
				// price ("Verbinden Schreiben Sie Ihren Brief + 15,00 ZŁ"). Strip the
				// trailing "+ price zł" so it doesn't render duplicated alongside our
				// price column. Matches +15zł / +15,00zł / + 7,90 ZŁ / + 2,00 ZŁ etc.
				titleText = titleText.replace(/\s*\+\s*[\d.,]+\s*z[łl]\s*$/i, '').trim();
			}
			// v63 — strip localized "Include" prefix in 5 languages (pl/uk/en/fr/de)
			titleText = titleText.replace(/^\s*(?:Dołącz|З[’']єднувати|Include|Inclure|Joindre|Hinzufügen|Beifügen|Додай|Додати)\s+/i, '');
			// Try the dedicated price element first (v21-restructured products), then
			// fall back to parsing the title for "+ N,NN zł" inline (Quiche-style),
			// then finally fall back to PRICE_OVERRIDES by canonical handle (v77d).
			var priceEl = cp.querySelector('.cross-product-price');
			var priceText = priceEl ? priceEl.textContent.trim() : '';
			if (!priceText) {
				var m = titleText.match(/^(.*?)\s*(\+\s*[\d.,]+\s*z[lł]\.?)\s*$/i);
				if (m) {
					titleText = m[1].trim();
					priceText = '+ ' + m[2].replace(/^\+\s*/, '').replace(/z[lł]\.?$/i, '').trim() + ' zł';
				}
			}
			// v77d: PRICE_OVERRIDES fallback for products where Pipeline renders bare titles
			if (!priceText && PRICE_OVERRIDES[handle]) priceText = PRICE_OVERRIDES[handle];
			// v79 (2026-05-08): capture the inputWrapper so we can move it into
			// the row's expanded panel — same pattern v29 uses for Full mode.
			// Without this, toggling on Napisz swój list / Świeczka cyferka
			// would activate the underlying checkbox but the user has no way
			// to type the message / pick a digit (the input lives in the
			// hidden cross-products container).
			var inputWrapper = cp.querySelector('.cross-product__input-wrapper');
			return { handle: handle, checkbox: checkbox, titleText: titleText, priceText: priceText, inputWrapper: inputWrapper };
		});

		// Don't build if titles haven't restructured yet
		if (crossProducts.length === 0) return false;
		if (crossProducts.every(function (cp) { return !cp.titleText; })) return false;

		// 1. Hide the stray cake-text input (no Napis variant → no purpose)
		var litem = document.querySelector('.line-item-property__field.litem');
		if (litem) litem.style.display = 'none';

		// 2. Build wrapper + card
		// Label gets BOTH classes so it matches Funfetti's PERSONALIZACJA spacing/typography
		var wrapper = document.createElement('div');
		wrapper.className = 'batida-addon-section batida-addon-section--addons-only';
		wrapper.setAttribute('data-from', 'addons');
		// v77d (2026-05-08): unified title across modes (Caroline picked Option A).
		// Was previously `perso.section_title_addons_only` ("Dodatki" alone). Now uses
		// the same `perso.section_title` as v29 for visual consistency between
		// cake products and bez-wariantow (monoporcje, coffee, quiche).
		wrapper.innerHTML = '<p class="batida-addon-section__label batida-section-label">' + window.batidaT('perso.section_title', 'Personalizacja / Dodatki') + '</p>';

		var card = document.createElement('div');
		card.className = 'batida-perso-card';

		crossProducts.forEach(function (cp) {
			if (!cp.titleText) return;
			var subtitle = SUBTITLES[cp.handle] || '';
			var hasIcon = INFO_HANDLES.indexOf(cp.handle) !== -1;
			var isOn = cp.checkbox && cp.checkbox.checked;
			var row = document.createElement('div');
			row.className = 'batida-perso-row';
			if (cp.handle) row.setAttribute('data-handle', cp.handle);
			var titleHTML = cp.titleText + (hasIcon ? svgInfo() : '');
			row.innerHTML =
				'<div class="batida-perso-title-col"><p class="batida-perso-title">' + titleHTML + '</p>' +
				(subtitle ? '<p class="batida-perso-subtitle">' + subtitle + '</p>' : '') + '</div>' +
				'<div class="batida-perso-price-col">' + cp.priceText + '</div>' +
				'<div class="batida-perso-toggle-col"><button type="button" class="batida-perso-toggle' + (isOn ? ' is-on' : '') + '" aria-pressed="' + (isOn ? 'true' : 'false') + '"><span class="dot"></span></button></div>';
			card.appendChild(row);

			// v79 (2026-05-08): port v29's expansion pattern into v52 (Addons-only mode).
			// Without this, toggling on Napisz swój list / Świeczka cyferka activated
			// the underlying cross-product checkbox but the typing input / digit picker
			// stayed hidden inside the legacy `.cross-products` container — so users
			// on bez-wariantow products (Duet mono porcja, coffee, quiche) couldn't
			// actually enter their message. Mirrors v29 lines ~2405-2456.
			var exp = document.createElement('div');
			exp.className = 'batida-perso-expanded';
			if (cp.inputWrapper) exp.appendChild(cp.inputWrapper);
			// v79: wrap any visible number qty input with +/- stepper (same as v29).
			(function wrapWithStepper() {
				var qtyInput = exp.querySelector('.cross-product__input[type="number"]');
				if (!qtyInput || qtyInput.__batidaStepperWrapped) return;
				qtyInput.__batidaStepperWrapped = true;
				var stepper = document.createElement('div');
				stepper.className = 'batida-perso-stepper';
				var minus = document.createElement('button');
				minus.type = 'button';
				minus.className = 'batida-perso-stepper__btn batida-perso-stepper__btn--minus';
				minus.setAttribute('aria-label', '−');
				minus.textContent = '−';
				var plus = document.createElement('button');
				plus.type = 'button';
				plus.className = 'batida-perso-stepper__btn batida-perso-stepper__btn--plus';
				plus.setAttribute('aria-label', '+');
				plus.textContent = '+';
				qtyInput.parentNode.insertBefore(stepper, qtyInput);
				stepper.appendChild(minus);
				stepper.appendChild(qtyInput);
				stepper.appendChild(plus);
				function bump(delta) {
					var v = parseInt(qtyInput.value, 10) || 1;
					var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
					var max = parseInt(qtyInput.getAttribute('max'), 10) || 999;
					qtyInput.value = Math.max(min, Math.min(max, v + delta));
					qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
					qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
				}
				minus.addEventListener('click', function (e) { e.preventDefault(); bump(-1); });
				plus.addEventListener('click', function (e) { e.preventDefault(); bump(+1); });
			})();
			if (!isOn) exp.setAttribute('hidden', '');
			card.appendChild(exp);

			row.querySelector('.batida-perso-toggle').addEventListener('click', function () {
				var on = !this.classList.contains('is-on');
				this.classList.toggle('is-on', on);
				this.setAttribute('aria-pressed', on ? 'true' : 'false');
				if (cp.checkbox) {
					cp.checkbox.checked = on;
					cp.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
				}
				if (on) exp.removeAttribute('hidden');
				else exp.setAttribute('hidden', '');
			});
		});
		wrapper.appendChild(card);

		// 3. Insert before the legacy container, then hide the legacy
		cpContainer.parentNode.insertBefore(wrapper, cpContainer);
		cpContainer.style.display = 'none';

		return true;
	}

	var initTries = 0;
	function init() {
		if (build()) return;
		if (++initTries > 100) return; // 24.09 audit: stop after ~10 s instead of polling forever
		setTimeout(init, 100);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


/* =====================================================================
   v58 — Global ZIP filter handler (Pat 2026-05-05)
   Replaces 100+ KB of per-card inline <script> + ZIP-list strings with a
   single global handler that reads `data-batida-zone="A|AB"` markers
   emitted by snippets/product-grid-item-variant.liquid + product-clip.liquid.
   The eligibility flags hide_all_products / show_all_products are still
   set by zip-cookies.liquid as before — this handler only consumes them.
   Custom-zone products (not matching settings.group_a or group_a+group_b)
   keep their inline <script> fallback in the snippets.
   Logic mirrored exactly from the original per-card scripts so behavior
   is identical: Group A user → see all; Group B user → hide A-only;
   no-cookie / browse → fade ATC on everything.
   ===================================================================== */

(function v58ZipFilter() {
	function applyV58Filter(scope) {
		var root = scope || document;
		var hideAll = (typeof window.hide_all_products !== 'undefined') && window.hide_all_products === true;
		var showAll = (typeof window.show_all_products !== 'undefined') && window.show_all_products === true;
		var card_zip = (document.cookie.match(/(?:^|;\s*)zip_cookie=([^;]+)/) || [])[1] || '';

		var markers = root.querySelectorAll('[data-batida-zone]');
		markers.forEach(function (marker) {
			if (marker.getAttribute('data-v58-applied') === '1') return;
			marker.setAttribute('data-v58-applied', '1');

			var zone = marker.getAttribute('data-batida-zone');
			// Custom-target selectors used by product-clip.liquid; otherwise default to outer card
			var clipTarget = marker.getAttribute('data-batida-clip-target');
			var clipUpsell = marker.getAttribute('data-batida-clip-upsell');

			// v59 (2026-05-17): the previous selectors threw "is not a valid selector"
			// whenever the product ID started with a digit (i.e. every product). HTML
			// happily accepts digit-starting class/id values, but CSS identifier rules
			// reject them. Switched to attribute-selector form for both branches —
			// works on any product ID without modifying the underlying class/id names.
			// product-clip.liquid now emits a CSS-safe attribute selector in
			// data-batida-clip-target, so the clipTarget branch passes through as-is.
			var card;
			if (clipTarget) {
				card = document.querySelector(clipTarget);
			} else if (clipUpsell) {
				card = document.querySelector('[class~="' + clipUpsell + '-btn-upsell"], [id="' + clipUpsell + '-btn-upsell"]');
			} else {
				// product-grid-item-variant case: marker is inside the variant
				var variant = marker.closest('product-grid-item-variant');
				card = (variant && variant.closest('product-grid-item')) || variant || marker.parentElement;
			}
			if (!card) return;

			if (hideAll) {
				if (clipUpsell) {
					// preserve original upsell behavior: jQuery .hide()
					if (window.jQuery) window.jQuery(card).hide();
				} else {
					if (card.classList) card.classList.add('hide_atc_info');
				}
				return;
			}
			if (showAll) {
				// Group A user (Warsaw or browse mode) — show everything
				if (card.classList) card.classList.remove('hidden_product');
				if (clipUpsell && window.jQuery) window.jQuery(card).show();
				return;
			}
			// Group B user (DPD-only zip) — hide Warsaw-only products
			if (zone === 'A') {
				if (clipUpsell) {
					if (window.jQuery) window.jQuery(card).hide();
				} else {
					if (card.classList) card.classList.add('hidden_product');
					// Zone gate 2026-09-24: a greyed small card (product-clip) must not
					// quick-add a product this zone can't get (CSS greys it out in
					// batida-zip-hint.css; this also stops keyboard activation).
					// Alpine's :disabled binding resets `disabled`, so the capture-phase
					// click guard in init() is what actually blocks it.
					if (card.querySelectorAll) card.querySelectorAll('.product-clip__btn').forEach(function (b) {
						b.disabled = true;
						b.setAttribute('aria-disabled', 'true');
						b.setAttribute('tabindex', '-1');
					});
				}
			} else {
				// zone === 'AB' (Warsaw + DPD): show
				if (card.classList) card.classList.remove('hidden_product');
				if (clipUpsell && window.jQuery) window.jQuery(card).show();
			}
		});
	}

	function init() {
		applyV58Filter();
		// Re-run after lazy-loaded sections mount (collection scrollers, recommendations)
		setTimeout(applyV58Filter, 800);
		setTimeout(applyV58Filter, 2500);
		// Zone gate 2026-09-24: a greyed small card's add button does nothing
		// (covers keyboard and programmatic clicks; CSS covers the mouse).
		document.addEventListener('click', function (e) {
			if (e.target && e.target.closest && e.target.closest('.quickview.hidden_product .product-clip__btn')) {
				e.preventDefault();
				e.stopImmediatePropagation();
			}
		}, true);
		// Watch for new markers added later (e.g. recommendations API top-up)
		try {
			var mo = new MutationObserver(function (muts) {
				var sawNewMarker = muts.some(function (m) {
					return Array.from(m.addedNodes || []).some(function (n) {
						return n.nodeType === 1 && (n.matches && n.matches('[data-batida-zone]') || n.querySelector && n.querySelector('[data-batida-zone]'));
					});
				});
				if (sawNewMarker) applyV58Filter();
			});
			mo.observe(document.body, { childList: true, subtree: true });
		} catch (e) {}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// Expose for debugging / manual re-run
	window.__batidaV58Filter = applyV58Filter;
})();


/* =====================================================================
   v77 (2026-05-08) — Move OPIS description below image gallery on desktop
   Caroline + Pat 2026-05-08: the empty white space below the image gallery
   on tall right-column products (especially monoporcje + coffee) was
   unsightly. Description naturally fits there. On mobile we keep the
   single-column flow with description at the bottom (standard mobile UX).
   Affects every product template (default, dc-pc, bez-wariantow, etc.)
   since the .product__block__description element renders in all of them.
   ===================================================================== */

/* v77c (2026-05-08): MOVED to assets/batida-desc-layout.js — was being
   minifier-comma-chained with prior IIFEs, causing v58 exceptions on
   bez-wariantow products to abort v77 init. New module is loaded
   independently via snippets/zip-cookies.liquid like other batida-*.js files. */
